"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1190],{

/***/ 87654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n  \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5a39cb26-0"
}).withConfig({
    componentId: "sc-c116ed01-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);


/***/ }),

/***/ 14275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-d9299de2-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 41273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useVaultApy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9941);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43038);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20335);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21046);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79833);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_toString__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33206);
/* harmony import */ var config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23637);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49770);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55878);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35128);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9070);
/* harmony import */ var _utils_multicall__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41144);















var masterChefAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getMasterChefAddress */ .Oc)();
// default
var DEFAULT_PERFORMANCE_FEE_DECIMALS = 2;
var PRECISION_FACTOR = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .BigNumber.from */ .O$.from("1000000000000");
var getFlexibleApy = function(totalCakePoolEmissionPerYear, pricePerFullShare, totalShares) {
    return totalCakePoolEmissionPerYear.mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(_ethersproject_constants__WEBPACK_IMPORTED_MODULE_12__/* .WeiPerEther */ .Ce)).divUnsafe(pricePerFullShare).divUnsafe(totalShares).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(100));
};
var _getBoostFactor = function(boostWeight, duration, durationFactor) {
    // if(Number.isNaN(duration))
    var length = Number.isNaN(duration) ? 0 : duration;
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(boostWeight).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(Math.max(length, 0))).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(durationFactor)).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(PRECISION_FACTOR));
};
var getLockedApy = function(flexibleApy, boostFactor) {
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1")));
};
var cakePoolPID = 0;
function useVaultApy() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _duration = ref.duration, duration = _duration === void 0 ? config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .MAX_LOCK_DURATION */ .VO : _duration;
    var ref1 = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCakeVault */ .Xo)(), _totalShares = ref1.totalShares, totalShares = _totalShares === void 0 ? utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW : _totalShares, _pricePerFullShare = ref1.pricePerFullShare, pricePerFullShare = _pricePerFullShare === void 0 ? utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW : _pricePerFullShare, tmp = ref1.fees, performanceFeeAsDecimal = (tmp === void 0 ? {
        performanceFeeAsDecimal: DEFAULT_PERFORMANCE_FEE_DECIMALS
    } : tmp).performanceFeeAsDecimal;
    var totalSharesAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(totalShares.toString());
    }, [
        totalShares
    ]);
    var pricePerFullShareAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(pricePerFullShare.toString());
    }, [
        pricePerFullShare
    ]);
    var ref2 = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("masterChef-total-cake-pool-emission", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var calls, ref, ref1, specialFarmsPerBlock, cakePoolInfo, ref2, totalSpecialAllocPoint, cakePoolSharesInSpecialFarms;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = [
                        {
                            address: masterChefAddress,
                            name: "rp1PerBlock",
                            params: [
                                false
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "poolInfo",
                            params: [
                                cakePoolPID
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "totalSpecialAllocPoint"
                        }
                    ];
                    return [
                        4,
                        (0,_utils_multicall__WEBPACK_IMPORTED_MODULE_9__/* .multicallv2 */ .v)(config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__, calls)
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(ref[0], 1), specialFarmsPerBlock = ref1[0], cakePoolInfo = ref[1], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(ref[2], 1), totalSpecialAllocPoint = ref2[0];
                    cakePoolSharesInSpecialFarms = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(cakePoolInfo.allocPoint).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(totalSpecialAllocPoint));
                    return [
                        2,
                        _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(specialFarmsPerBlock).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(config__WEBPACK_IMPORTED_MODULE_1__/* .BLOCKS_PER_YEAR */ .Bi)).mulUnsafe(cakePoolSharesInSpecialFarms)
                    ];
            }
        });
    })), totalCakePoolEmissionPerYear = ref2.data;
    var flexibleApy = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return totalCakePoolEmissionPerYear && !pricePerFullShareAsEtherBN.isZero() && !totalSharesAsEtherBN.isZero() && getFlexibleApy(totalCakePoolEmissionPerYear, pricePerFullShareAsEtherBN, totalSharesAsEtherBN).toString();
    }, [
        pricePerFullShareAsEtherBN,
        totalCakePoolEmissionPerYear,
        totalSharesAsEtherBN
    ]);
    var boostFactor = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .BOOST_WEIGHT */ .xt, duration, config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .DURATION_FACTOR */ .A0);
    }, [
        duration
    ]);
    var lockedApy = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return flexibleApy && getLockedApy(flexibleApy, boostFactor).toString();
    }, [
        boostFactor,
        flexibleApy
    ]);
    var getBoostFactor = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .BOOST_WEIGHT */ .xt, adjustDuration, config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .DURATION_FACTOR */ .A0);
    }, []);
    var flexibleApyNoFee = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (flexibleApy && performanceFeeAsDecimal) {
            var rewardPercentageNoFee = lodash_toString__WEBPACK_IMPORTED_MODULE_0___default()(1 - performanceFeeAsDecimal / 100);
            return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(rewardPercentageNoFee)).toString();
        }
        return flexibleApy;
    }, [
        flexibleApy,
        performanceFeeAsDecimal
    ]);
    return {
        flexibleApy: flexibleApyNoFee,
        lockedApy: lockedApy,
        getLockedApy: (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
            return flexibleApy && getLockedApy(flexibleApy, getBoostFactor(adjustDuration)).toString();
        }, [
            flexibleApy,
            getBoostFactor
        ]),
        boostFactor: (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
            return boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            boostFactor
        ]),
        getBoostFactor: (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
            return getBoostFactor(adjustDuration).addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            getBoostFactor
        ])
    };
}


/***/ }),

/***/ 23637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xo": function() { return /* binding */ useCakeVault; },
  "AI": function() { return /* binding */ usePool; },
  "l7": function() { return /* binding */ usePoolsPageFetch; },
  "f6": function() { return /* binding */ usePoolsWithVault; },
  "eB": function() { return /* binding */ useVaultPoolByKey; },
  "KV": function() { return /* binding */ useVaultPools; }
});

// UNUSED EXPORTS: useFetchPublicPoolsData, useFetchUserPools, usePools

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(27892);
// EXTERNAL MODULE: ./src/config/constants/farms.ts
var farms = __webpack_require__(81115);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var state_farms = __webpack_require__(36393);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/state/pools/helpers.ts
var helpers = __webpack_require__(89713);
;// CONCATENATED MODULE: ./src/state/pools/selectors.ts







var selectPoolsData = function(state) {
    return state.pools.data;
};
var selectPoolData = function(sousId) {
    return function(state) {
        return state.pools.data.find(function(p) {
            return p.sousId === sousId;
        });
    };
};
var selectUserDataLoaded = function(state) {
    return state.pools.userDataLoaded;
};
var selectVault = function(key) {
    return function(state) {
        return key ? state.pools[key] : pools/* initialPoolVaultState */.XW;
    };
};
var makePoolWithUserDataLoadingSelector = function(sousId) {
    return (0,reselect_es/* createSelector */.P1)([
        selectPoolData(sousId),
        selectUserDataLoaded
    ], function(pool, userDataLoaded) {
        return {
            pool: (0,helpers/* transformPool */.xK)(pool),
            userDataLoaded: userDataLoaded
        };
    });
};
var selectors_poolsWithUserDataLoadingSelector = (0,reselect_es/* createSelector */.P1)([
    selectPoolsData,
    selectUserDataLoaded
], function(pools, userDataLoaded) {
    return {
        pools: pools.map(helpers/* transformPool */.xK),
        userDataLoaded: userDataLoaded
    };
});
var makeVaultPoolByKey = function(key) {
    return (0,reselect_es/* createSelector */.P1)([
        selectVault(key)
    ], function(vault) {
        return (0,helpers/* transformLockedVault */.XN)(vault);
    });
};
var poolsWithVaultSelector = (0,reselect_es/* createSelector */.P1)([
    selectors_poolsWithUserDataLoadingSelector,
    makeVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault)
], function(poolsWithUserDataLoading, deserializedCakeVault) {
    var pools = poolsWithUserDataLoading.pools, userDataLoaded = poolsWithUserDataLoading.userDataLoaded;
    var cakePool = pools.find(function(pool) {
        return !pool.isFinished && pool.sousId === 0;
    });
    if (cakePool) {
        var withoutCakePool = pools.filter(function(pool) {
            return pool.sousId !== 0;
        });
        var cakeAutoVault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cakePool, deserializedCakeVault), {
            vaultKey: types/* VaultKey.CakeVault */.om.CakeVault,
            userData: (0,_object_spread/* default */.Z)({}, cakePool.userData, deserializedCakeVault.userData)
        });
        var cakeAutoVaultWithApr = (0,_object_spread/* default */.Z)({}, cakeAutoVault);
        return {
            pools: [
                cakeAutoVaultWithApr
            ].concat((0,_to_consumable_array/* default */.Z)(withoutCakePool)),
            userDataLoaded: userDataLoaded
        };
    }
    return true;
});

;// CONCATENATED MODULE: ./src/state/pools/hooks.ts














var useFetchPublicPoolsData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function(currentBlock) {
        var fetchPoolsDataWithFarms = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var activeFarms;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            activeFarms = farms/* default.filter */.Z.filter(function(farm) {
                                return farm.pid !== 0 && farm.pid !== 1 && farm.pid !== 2;
                            });
                            // @ts-ignore
                            return [
                                4,
                                dispatch((0,state_farms/* fetchFarmsPublicDataAsync */.eG)(activeFarms.map(function(farm) {
                                    return farm.pid;
                                })))
                            ];
                        case 1:
                            _state.sent();
                            (0,es/* batch */.dC)(function() {
                                // @ts-ignore
                                dispatch((0,pools/* fetchPoolsPublicDataAsync */.ht)(currentBlock));
                                // @ts-ignore
                                dispatch((0,pools/* fetchPoolsStakingLimitsAsync */.E$)());
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPoolsDataWithFarms() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPoolsDataWithFarms();
    }, [
        dispatch
    ]);
};
var useFetchUserPools = function(account) {
    var dispatch = useAppDispatch();
    useFastRefreshEffect(function() {
        if (account) {
            // @ts-ignore
            dispatch(fetchPoolsUserDataAsync(account));
        }
    }, [
        account,
        dispatch
    ]);
};
var usePools = function() {
    return useSelector(poolsWithUserDataLoadingSelector);
};
var usePool = function(sousId) {
    var poolWithUserDataLoadingSelector = (0,react.useMemo)(function() {
        return makePoolWithUserDataLoadingSelector(sousId);
    }, [
        sousId
    ]);
    return (0,es/* useSelector */.v9)(poolWithUserDataLoadingSelector);
};
var usePoolsWithVault = function() {
    return (0,es/* useSelector */.v9)(poolsWithVaultSelector);
};
var usePoolsPageFetch = function() {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    useFetchPublicPoolsData();
    (0,useRefreshEffect/* useFastRefreshEffect */.a)(function() {
        (0,es/* batch */.dC)(function() {
            // @ts-ignore
            dispatch((0,pools/* fetchCakeVaultPublicData */.P4)());
            if (address) {
                // @ts-ignore
                dispatch((0,pools/* fetchPoolsUserDataAsync */.XK)(address));
                // @ts-ignore
                dispatch((0,pools/* fetchCakeVaultUserData */.x$)({
                    account: address
                }));
            }
        });
    }, [
        address,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        (0,es/* batch */.dC)(function() {
            // @ts-ignore
            dispatch((0,pools/* fetchCakeVaultFees */.HX)());
        });
    }, [
        dispatch
    ]);
};
var useCakeVault = function() {
    return useVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault);
};
var useVaultPools = function() {
    var cakeVault = useVaultPoolByKey(types/* VaultKey.CakeVault */.om.CakeVault);
    var vaults = (0,react.useMemo)(function() {
        return (0,_define_property/* default */.Z)({}, types/* VaultKey.CakeVault */.om.CakeVault, cakeVault);
    }, [
        cakeVault
    ]);
    return vaults;
};
var useVaultPoolByKey = function(key) {
    var vaultPoolByKey = (0,react.useMemo)(function() {
        return makeVaultPoolByKey(key);
    }, [
        key
    ]);
    return (0,es/* useSelector */.v9)(vaultPoolByKey);
};


/***/ }),

/***/ 17101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IM": function() { return /* binding */ isStaked; },
/* harmony export */   "PS": function() { return /* binding */ VaultPosition; },
/* harmony export */   "cP": function() { return /* binding */ getVaultPosition; },
/* harmony export */   "p1": function() { return /* binding */ isLocked; }
/* harmony export */ });
/* unused harmony exports isLockedEnd, isAfterBurning */
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9070);

var isStaked = function(param) {
    var userShares = param.userShares;
    return userShares && userShares.gt(0);
};
var isLocked = function(param) {
    var userShares = param.userShares, locked = param.locked;
    return isStaked({
        userShares: userShares
    }) && Boolean(locked) // && !isAfter(new Date(lockEndTime * 1000), new Date())
    ;
};
var isLockedEnd = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() >= parseInt(lockEndTime) * 1000 && Date.now() <= new Date(parseInt(lockEndTime) * 1000).getTime() + config_constants_pools__WEBPACK_IMPORTED_MODULE_0__/* .UNLOCK_FREE_DURATION */ .by * 1000;
};
var isAfterBurning = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime;
    return lockEndTime && lockEndTime !== "0" && isLocked({
        userShares: userShares,
        locked: locked
    }) && Date.now() > new Date(parseInt(lockEndTime) * 1000).getTime() + config_constants_pools__WEBPACK_IMPORTED_MODULE_0__/* .UNLOCK_FREE_DURATION */ .by * 1000;
};
var VaultPosition;
(function(VaultPosition) {
    VaultPosition[VaultPosition["None"] = 0] = "None";
    VaultPosition[VaultPosition["Flexible"] = 1] = "Flexible";
    VaultPosition[VaultPosition["Locked"] = 2] = "Locked";
    VaultPosition[VaultPosition["LockedEnd"] = 3] = "LockedEnd";
    VaultPosition[VaultPosition["AfterBurning"] = 4] = "AfterBurning";
})(VaultPosition || (VaultPosition = {}));
var getVaultPosition = function(params) {
    if (isAfterBurning(params)) {
        return VaultPosition.AfterBurning;
    }
    if (isLockedEnd(params)) {
        return VaultPosition.LockedEnd;
    }
    if (isLocked(params)) {
        return VaultPosition.Locked;
    }
    if (isStaked(params)) {
        return VaultPosition.Flexible;
    }
    return VaultPosition.None;
};


/***/ }),

/***/ 87218:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ }),

/***/ 14011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ distanceToNowStrict; },
/* harmony export */   "Ch": function() { return /* binding */ secondsToDay; },
/* harmony export */   "Eg": function() { return /* binding */ convertTimeToSeconds; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91713);

var secondsToDay = function(s) {
    return Math.floor(s / (24 * 60 * 60));
};
var convertTimeToSeconds = function(time) {
    return parseInt(time) * 1000;
};
// https://date-fns.org/v2.28.0/docs/formatDistanceToNowStrict
var distanceToNowStrict = function(timeInSeconds) {
    var endTime = new Date(timeInSeconds);
    return new Date() > endTime || !Number.isFinite(timeInSeconds) ? "0 seconds" : (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(endTime);
};


/***/ }),

/***/ 67802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44747);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9941);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(65528);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(20253);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47509);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(84091);
/* harmony import */ var components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97977);
/* harmony import */ var components_Balance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20922);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99150);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70794);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35128);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9070);
/* harmony import */ var state_block_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37063);
/* harmony import */ var views_Pools_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53136);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17166);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var AprLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8505a34-0"
})(_templateObject());
var Apr = function(_param) {
    var pool = _param.pool, showIcon = _param.showIcon, stakedBalance = _param.stakedBalance, _performanceFee = _param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_param, [
        "pool",
        "showIcon",
        "stakedBalance",
        "performanceFee"
    ]);
    var ref;
    var stakingToken = pool.stakingToken, earningToken = pool.earningToken, isFinished = pool.isFinished, earningTokenPrice = pool.earningTokenPrice, stakingTokenPrice = pool.stakingTokenPrice, userData = pool.userData, apr = pool.apr, rawApr = pool.rawApr, vaultKey = pool.vaultKey;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(new bignumber_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(0)), cakePriceUsd = ref1[0], setCakePriceUsd = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        // const pairAddress = getAddress(testnetTokens.rp1, testnetTokens.tusd)
        // const contract = getLpContract(pairAddress)
        // contract.getReserves().then((data) => {
        // const reserve1 = data._reserve1.toString()
        // const reserve0 = data._reserve0.toString()
        // const price = new BigNumber(reserve1).div(new BigNumber(reserve0))
        var price = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_11__/* .rp1PriceUsd */ .gt)();
        setCakePriceUsd(new bignumber_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(price));
    // return price
    // })
    }, []);
    var currentBlock = (0,state_block_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCurrentBlock */ .je)();
    var ref2 = (0,views_Pools_helpers__WEBPACK_IMPORTED_MODULE_9__/* .getPoolBlockInfo */ .zy)(pool, currentBlock), shouldShowBlockCountdown = ref2.shouldShowBlockCountdown, hasPoolStarted = ref2.hasPoolStarted;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new bignumber_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(userData.stakingTokenBalance) : utils_bigNumber__WEBPACK_IMPORTED_MODULE_6__/* .BIG_ZERO */ .HW;
    var apyModalLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    var ref3;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        earningTokenPrice: earningTokenPrice,
        stakingTokenPrice: cakePriceUsd.toNumber() || 0,
        stakingTokenBalance: stakedBalance.plus(stakingTokenBalance),
        apr: vaultKey ? rawApr : apr,
        stakingTokenSymbol: stakingToken.symbol,
        linkLabel: t("Get %symbol%", {
            symbol: stakingToken.symbol
        }),
        linkHref: apyModalLink,
        earningTokenSymbol: earningToken.symbol,
        autoCompoundFrequency: (ref3 = (ref = config_constants_pools__WEBPACK_IMPORTED_MODULE_7__/* .vaultPoolConfig */ .Y4[vaultKey]) === null || ref === void 0 ? void 0 : ref.autoCompoundFrequency) !== null && ref3 !== void 0 ? ref3 : 0,
        performanceFee: performanceFee
    })), 1), onPresentApyModal = ref4[0];
    var openRoiModal = function(event) {
        event.stopPropagation();
        onPresentApyModal();
    };
    var isValidate = apr !== undefined && !Number.isNaN(apr);
    /* && apr !== null */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AprLabelContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
        alignItems: "center",
        justifyContent: "flex-start"
    }, props), {
        children: isValidate || isFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: hasPoolStarted || !shouldShowBlockCountdown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_3__/* .BalanceWithLoading */ .sC, {
                        onClick: openRoiModal,
                        fontSize: "16px",
                        isDisabled: isFinished,
                        value: isFinished ? 0 : apr,
                        decimals: 2,
                        unit: "%"
                    }),
                    !isFinished && showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        onClick: openRoiModal,
                        variant: "text",
                        width: "20px",
                        height: "20px",
                        padding: "0px",
                        marginLeft: "4px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            color: "textSubtle",
                            width: "20px"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                children: "-"
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
            width: "80px",
            height: "16px"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Apr);


/***/ }),

/***/ 37528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97114);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99150);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76972);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23637);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53136);






var AutoEarningsBreakdown = function(param) {
    var pool = param.pool, account = param.account;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var earningTokenPrice = pool.earningTokenPrice;
    var ref = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useVaultPoolByKey */ .eB)(pool.vaultKey), _userData = ref.userData, cakeAtLastUserAction = _userData.cakeAtLastUserAction, userShares = _userData.userShares, lastUserActionTime = _userData.lastUserActionTime, currentOverdueFee = _userData.currentOverdueFee, currentPerformanceFee = _userData.currentPerformanceFee, userBoostedShare = _userData.userBoostedShare, pricePerFullShare = ref.pricePerFullShare;
    var ref1 = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getCakeVaultEarnings */ .UN)(account, cakeAtLastUserAction, userShares, pricePerFullShare, earningTokenPrice, currentPerformanceFee.plus(currentOverdueFee).plus(userBoostedShare)), autoCakeToDisplay = ref1.autoCakeToDisplay, autoUsdToDisplay = ref1.autoUsdToDisplay;
    var lastActionInMs = lastUserActionTime ? parseInt(lastUserActionTime) * 1000 : 0;
    var hourDiffSinceLastAction = (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Date.now(), lastActionInMs);
    var earnedCakePerHour = hourDiffSinceLastAction ? autoCakeToDisplay / hourDiffSinceLastAction : 0;
    var earnedUsdPerHour = hourDiffSinceLastAction ? autoUsdToDisplay / hourDiffSinceLastAction : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bold: true,
                children: [
                    autoCakeToDisplay.toFixed(3),
                    " CAKE"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bold: true,
                children: [
                    "~$",
                    autoUsdToDisplay.toFixed(2)
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: [
                    t("Earned since your last action"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: new Date(lastActionInMs).toLocaleString()
            }),
            hourDiffSinceLastAction ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: [
                            t("Your average per hour"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        bold: true,
                        children: t("CAKE per hour: %amount%", {
                            amount: earnedCakePerHour.toFixed(2)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        bold: true,
                        children: t("per hour: ~$%amount%", {
                            amount: earnedUsdPerHour.toFixed(2)
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoEarningsBreakdown);


/***/ }),

/***/ 33649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CakeVaultCard_UnstakingFeeCountdownRow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/views/Pools/hooks/useWithdrawalFeeTimer.ts
var useWithdrawalFeeTimer = __webpack_require__(99119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToHours/index.js
var secondsToHours = __webpack_require__(70008);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./src/utils/timeHelper.ts
var timeHelper = __webpack_require__(14011);
// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(87218);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/WithdrawalFeeTimer.tsx




var WithdrawalFeeTimer = function(param) {
    var secondsRemaining = param.secondsRemaining;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = ref.days, hours = ref.hours, minutes = ref.minutes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        bold: true,
        fontSize: "14px",
        children: t("%day%d:%hour%h:%minute%m", {
            day: days,
            hour: hours,
            minute: minutes
        })
    });
};
/* harmony default export */ var CakeVaultCard_WithdrawalFeeTimer = (WithdrawalFeeTimer);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/UnstakingFeeCountdownRow.tsx









var UnstakingFeeCountdownRow = function(param) {
    var isTableVariant = param.isTableVariant, vaultKey = param.vaultKey;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,hooks/* useVaultPoolByKey */.eB)(vaultKey), _userData = ref.userData, lastDepositedTime = _userData.lastDepositedTime, userShares = _userData.userShares, _fees = ref.fees, withdrawalFee = _fees.withdrawalFee, withdrawalFeePeriod = _fees.withdrawalFeePeriod;
    var feeAsDecimal = withdrawalFee / 100 || "-";
    var withdrawalDayPeriod = withdrawalFeePeriod ? (0,timeHelper/* secondsToDay */.Ch)(withdrawalFeePeriod) : "-";
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Unstaking fee: %fee%%", {
                    fee: feeAsDecimal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Only applies within %num% days of staking. Unstaking after %num% days will not include a fee. Timer resets every time you stake new CAKE in the pool.", {
                    num: withdrawalDayPeriod
                })
            })
        ]
    }), {
        placement: "bottom-start"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var ref2 = (0,useWithdrawalFeeTimer/* default */.Z)(parseInt(lastDepositedTime, 10), userShares, withdrawalFeePeriod), secondsRemaining = ref2.secondsRemaining, hasUnstakingFee = ref2.hasUnstakingFee;
    // The user has made a deposit, but has no fee
    var noFeeToPay = lastDepositedTime && !hasUnstakingFee && userShares.gt(0);
    // Show the timer if a user is connected, has deposited, and has an unstaking fee
    var shouldShowTimer = account && lastDepositedTime && hasUnstakingFee;
    var withdrawalFeePeriodHour = withdrawalFeePeriod ? (0,secondsToHours/* default */.Z)(withdrawalFeePeriod) : "-";
    var getRowText = function() {
        if (noFeeToPay) {
            return t("Unstaking Fee");
        }
        if (shouldShowTimer) {
            return t("unstaking fee before");
        }
        return t("unstaking fee if withdrawn within %num%h", {
            num: withdrawalFeePeriodHour
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: isTableVariant ? "flex-start" : "center",
        justifyContent: "space-between",
        flexDirection: isTableVariant ? "column" : "row",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipText/* default */.Z, {
                ref: targetRef,
                small: true,
                textTransform: "lowercase",
                children: [
                    noFeeToPay ? "0" : feeAsDecimal,
                    "% ",
                    getRowText()
                ]
            }),
            shouldShowTimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_WithdrawalFeeTimer, {
                secondsRemaining: secondsRemaining
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_UnstakingFeeCountdownRow = (UnstakingFeeCountdownRow);


/***/ }),

/***/ 86487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CakeVaultCard_VaultStakeModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx + 2 modules
var BalanceInput = __webpack_require__(35680);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(59739);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(47509);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(41273);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/views/Pools/hooks/useWithdrawalFeeTimer.ts
var useWithdrawalFeeTimer = __webpack_require__(99119);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/utils/compoundApyHelpers.ts
var compoundApyHelpers = __webpack_require__(43452);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var constants_pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/views/Pools/components/Vault/VaultRoiCalculatorModal.tsx + 1 modules
var VaultRoiCalculatorModal = __webpack_require__(58745);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/ConvertToLock.tsx
var ConvertToLock = __webpack_require__(24416);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/utils/timeHelper.ts
var timeHelper = __webpack_require__(14011);
// EXTERNAL MODULE: ./src/views/Pools/components/CakeVaultCard/UnstakingFeeCountdownRow.tsx + 1 modules
var UnstakingFeeCountdownRow = __webpack_require__(33649);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/FeeSummary.tsx







var FeeSummary = function(param) {
    var stakingTokenSymbol = param.stakingTokenSymbol, stakeAmount = param.stakeAmount, vaultKey = param.vaultKey;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,hooks/* useVaultPoolByKey */.eB)(vaultKey), _fees = ref.fees, withdrawalFee = _fees.withdrawalFee, withdrawalFeePeriod = _fees.withdrawalFeePeriod, lastDepositedTime = ref.userData.lastDepositedTime;
    var feeAsDecimal = withdrawalFee / 100;
    var feeInCake = (parseFloat(stakeAmount) * (feeAsDecimal / 100)).toFixed(4);
    var withdrawalDayPeriod = withdrawalFeePeriod ? (0,timeHelper/* secondsToDay */.Ch)(withdrawalFeePeriod) : "-";
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                mb: "4px",
                children: t("Unstaking fee: %fee%%", {
                    fee: feeAsDecimal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Only applies within %num% days of staking. Unstaking after %num% days will not include a fee. Timer resets every time you stake new CAKE in the pool.", {
                    num: withdrawalDayPeriod
                })
            })
        ]
    }), {
        placement: "top-start"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    var hasFeeToPay = lastDepositedTime && (0,useWithdrawalFeeTimer/* getHasWithdrawFee */.D)(parseInt(lastDepositedTime, 10), withdrawalFeePeriod);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    tooltipVisible && tooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                        ref: targetRef,
                        small: true,
                        children: t("Unstaking Fee")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        fontSize: "14px",
                        children: [
                            stakeAmount && hasFeeToPay ? feeInCake : "-",
                            " ",
                            stakingTokenSymbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstakingFeeCountdownRow/* default */.Z, {
                vaultKey: vaultKey
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_FeeSummary = (FeeSummary);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultStakeModal.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

























// min deposit and withdraw amount
var MIN_AMOUNT = new bignumber/* default */.Z(10000000000000);
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-6941e0f6-0"
})(_templateObject());
var AnnualRoiContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6941e0f6-1"
})(_templateObject1());
var AnnualRoiDisplay = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-6941e0f6-2"
})(_templateObject2());
var VaultStakeModal = function(param) {
    var pool = param.pool, stakingMax = param.stakingMax, performanceFee = param.performanceFee, _isRemovingStake = param.isRemovingStake, isRemovingStake = _isRemovingStake === void 0 ? false : _isRemovingStake, onDismiss = param.onDismiss;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var stakingToken = pool.stakingToken, earningTokenPrice = pool.earningTokenPrice, vaultKey = pool.vaultKey;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)();
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey), _userData = ref1.userData, lastDepositedTime = _userData.lastDepositedTime, userShares = _userData.userShares, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.Z)().theme;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref2 = (0,react.useState)(""), stakeAmount = ref2[0], setStakeAmount = ref2[1];
    var ref3 = (0,react.useState)(0), percent = ref3[0], setPercent = ref3[1];
    var ref4 = (0,react.useState)(false), showRoiCalculator = ref4[0], setShowRoiCalculator = ref4[1];
    var hasUnstakingFee = (0,useWithdrawalFeeTimer/* default */.Z)(parseInt(lastDepositedTime, 10), userShares).hasUnstakingFee;
    var cakePriceBusd = (0,bignumber/* default */.Z)(localStorage.getItem("price"));
    var usdValueStaked = new bignumber/* default */.Z(stakeAmount).times(cakePriceBusd);
    var formattedUsdValueStaked = cakePriceBusd.gt(0) && stakeAmount ? (0,formatBalance/* formatNumber */.uf)(usdValueStaked.toNumber()) : "";
    var flexibleApy = (0,useVaultApy/* useVaultApy */.o)().flexibleApy;
    var callOptions = {
        gasLimit: constants_pools/* vaultPoolConfig */.Y4[pool.vaultKey].gasLimit
    };
    var interestBreakdown = (0,compoundApyHelpers/* getInterestBreakdown */.A1)({
        principalInUSD: !usdValueStaked.isNaN() ? usdValueStaked.toNumber() : 0,
        apr: +flexibleApy,
        earningTokenPrice: earningTokenPrice,
        performanceFee: performanceFee,
        compoundFrequency: 0
    });
    var annualRoi = interestBreakdown[3] * pool.earningTokenPrice;
    var formattedAnnualRoi = (0,formatBalance/* formatNumber */.uf)(annualRoi, annualRoi > 10000 ? 0 : 2, annualRoi > 10000 ? 0 : 2);
    var getTokenLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    var convertedStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(stakeAmount), stakingToken.decimals);
    var handleStakeInputChange = function(input) {
        if (input) {
            var convertedInput = new bignumber/* default */.Z(input).multipliedBy(bigNumber/* BIG_TEN.pow */.xp.pow(stakingToken.decimals));
            var percentage = Math.floor(convertedInput.dividedBy(stakingMax).multipliedBy(100).toNumber());
            setPercent(percentage > 100 ? 100 : percentage);
        } else {
            setPercent(0);
        }
        setStakeAmount(input);
    };
    var handleChangePercent = function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = stakingMax.dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingToken.decimals, stakingToken.decimals);
            setStakeAmount(amountToStake);
        } else {
            setStakeAmount("");
        }
        setPercent(sliderPercent);
    };
    var handleWithdrawal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isWithdrawingAll, receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isWithdrawingAll = stakingMax.minus(convertedStakeAmount).lte(MIN_AMOUNT);
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                // .toString() being called to fix a BigNumber error in prod
                                // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                                return isWithdrawingAll ? callWithGasPrice(vaultPoolContract, "withdrawAll", undefined, callOptions) : callWithGasPrice(vaultPoolContract, "withdrawByAmount", [
                                    convertedStakeAmount.toString()
                                ], callOptions);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Unstaked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            // @ts-ignore
                            dispatch((0,pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleWithdrawal() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeposit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lockDuration, receipt;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        lockDuration = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0;
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                // .toString() being called to fix a BigNumber error in prod
                                // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                                var methodArgs = [
                                    convertedStakeAmount.toString(),
                                    lockDuration.toString()
                                ];
                                return callWithGasPrice(vaultPoolContract, "deposit", methodArgs, callOptions);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the pool")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            // @ts-ignore
                            dispatch((0,pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeposit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (isRemovingStake) {
                    // unstaking
                    handleWithdrawal();
                } else {
                    // staking
                    handleDeposit();
                }
                return [
                    2
                ];
            });
        });
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal/* VaultRoiCalculatorModal */.E, {
            pool: pool,
            linkLabel: t("Get %symbol%", {
                symbol: stakingToken.symbol
            }),
            linkHref: getTokenLink,
            stakingTokenBalance: cakeAsBigNumber.plus(stakingMax),
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: stakeAmount,
            performanceFee: performanceFee
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: isRemovingStake ? t("Unstake") : t("Stake in Pool"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        children: [
                            isRemovingStake ? t("Unstake") : t("Stake"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingToken.address, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingToken.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingToken.symbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                value: stakeAmount,
                onUserInput: handleStakeInputChange,
                currencyValue: cakePriceBusd.gt(0) && "~".concat(formattedUsdValueStaked || 0, " USD"),
                decimals: stakingToken.decimals
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "8px",
                ml: "auto",
                color: "textSubtle",
                fontSize: "12px",
                mb: "8px",
                children: t("Balance: %balance%", {
                    balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingMax, stakingToken.decimals)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                min: 0,
                max: 100,
                value: percent,
                onValueChanged: handleChangePercent,
                name: "stake",
                valueLabel: "".concat(percent, "%"),
                step: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mt: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(25);
                        },
                        children: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(50);
                        },
                        children: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(75);
                        },
                        children: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(100);
                        },
                        children: t("Max")
                    })
                ]
            }),
            isRemovingStake && hasUnstakingFee && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_FeeSummary, {
                vaultKey: vaultKey,
                stakingTokenSymbol: stakingToken.symbol,
                stakeAmount: stakeAmount
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    Number.isFinite(annualRoi) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiContainer, {
                        alignItems: "center",
                        onClick: function() {
                            setShowRoiCalculator(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiDisplay, {
                                children: [
                                    "$",
                                    formattedAnnualRoi
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                    color: "textSubtle",
                                    width: "18px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 60
                    })
                ]
            }),
            cakeAsNumberBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: "8px",
                maxWidth: "370px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvertToLock/* default */.Z, {
                    stakingToken: stakingToken,
                    currentStakedAmount: cakeAsNumberBalance
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                isLoading: pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "currentColor"
                }) : null,
                onClick: handleConfirmClick,
                disabled: !stakeAmount || parseFloat(stakeAmount) === 0 || stakingMax.lt(convertedStakeAmount),
                mt: "24px",
                children: pendingTx ? t("Confirming") : t("Confirm")
            }),
            !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mt: "8px",
                as: "a",
                external: true,
                href: getTokenLink,
                variant: "secondary",
                children: t("Get %symbol%", {
                    symbol: stakingToken.symbol
                })
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_VaultStakeModal = (VaultStakeModal);


/***/ }),

/***/ 90706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Buttons_AddCakeButton; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
// EXTERNAL MODULE: ./src/utils/timeHelper.ts
var timeHelper = __webpack_require__(14011);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Modals/RoiCalculatorModalProvider.tsx
var RoiCalculatorModalProvider = __webpack_require__(37972);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/BalanceField.tsx + 1 modules
var BalanceField = __webpack_require__(24594);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/LockedModalBody.tsx + 1 modules
var LockedModalBody = __webpack_require__(84548);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/index.tsx + 6 modules
var Overview = __webpack_require__(70271);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/AddAmountModal.tsx













var RenewDuration = function(param) {
    var setCheckedState = param.setCheckedState, checkedState = param.checkedState;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !checkedState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    children: t("Adding more CAKE will renew your lock, setting it to remaining duration. Due to shorter lock period, benefits decrease. To keep similar benefits, extend your lock.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checkedState,
                        onChange: function() {
                            return setCheckedState(function(prev) {
                                return !prev;
                            });
                        },
                        scale: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "8px",
                        color: "text",
                        children: t("Renew and extend your lock to keep similar benefits.")
                    })
                ]
            })
        ]
    });
};
var AddAmountModal = function(param) {
    var onDismiss = param.onDismiss, currentBalance = param.currentBalance, currentLockedAmount = param.currentLockedAmount, stakingToken = param.stakingToken, passedDuration = param.passedDuration, remainingDuration = param.remainingDuration, lockEndTime = param.lockEndTime, stakingTokenBalance = param.stakingTokenBalance;
    var theme = (0,useTheme/* default */.Z)().theme;
    var ref = (0,react.useState)("0"), lockedAmount = ref[0], setLockedAmount = ref[1];
    var ref1 = (0,react.useState)(false), checkedState = ref1[0], setCheckedState = ref1[1];
    var t = (0,Localization/* useTranslation */.$G)().t;
    var lockedAmountAsBigNumber = new bignumber/* default */.Z(lockedAmount);
    var totalLockedAmount = (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmount.plus((0,formatBalance/* getDecimalAmount */.Qe)(lockedAmountAsBigNumber)));
    var currentLockedAmountAsBalance = (0,formatBalance/* getBalanceAmount */.U4)(currentLockedAmount);
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(lockedAmountAsBigNumber.toNumber());
    var usdValueNewStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(totalLockedAmount);
    var prepConfirmArg = (0,react.useCallback)(function() {
        return {
            finalDuration: checkedState ? passedDuration : 0
        };
    }, [
        checkedState,
        passedDuration
    ]);
    var customOverview = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview/* default */.Z, {
            isValidDuration: true,
            openCalculator: (noop_default()),
            duration: remainingDuration,
            newDuration: checkedState ? passedDuration + remainingDuration : null,
            lockedAmount: currentLockedAmountAsBalance.toNumber(),
            newLockedAmount: totalLockedAmount,
            usdValueStaked: usdValueNewStaked,
            lockEndTime: lockEndTime
        });
    }, [
        remainingDuration,
        checkedState,
        currentLockedAmountAsBalance,
        passedDuration,
        totalLockedAmount,
        usdValueNewStaked,
        lockEndTime, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModalProvider/* default */.Z, {
        lockedAmount: lockedAmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            style: {
                maxWidth: "420px"
            },
            title: t("Add CAKE"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceField/* default */.Z, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        stakingDecimals: stakingToken.decimals,
                        lockedAmount: lockedAmount,
                        usedValueStaked: usdValueStaked,
                        stakingMax: currentBalance,
                        setLockedAmount: setLockedAmount,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedModalBody/* default */.Z, {
                    currentBalance: currentBalance,
                    stakingToken: stakingToken,
                    onDismiss: onDismiss,
                    lockedAmount: lockedAmountAsBigNumber,
                    editAmountOnly: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenewDuration, {
                        checkedState: checkedState,
                        setCheckedState: setCheckedState
                    }),
                    prepConfirmArg: prepConfirmArg,
                    customOverview: customOverview
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_AddAmountModal = (AddAmountModal);

// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/Modals/NotEnoughTokensModal.tsx
var NotEnoughTokensModal = __webpack_require__(67576);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/AddCakeButton.tsx










var AddCakeButton = function(param) {
    var currentBalance = param.currentBalance, stakingToken = param.stakingToken, currentLockedAmount = param.currentLockedAmount, lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime, stakingTokenBalance = param.stakingTokenBalance;
    var userDataLoaded = (0,hooks/* usePoolsWithVault */.f6)().userDataLoaded;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var remainingDuration = (0,react.useMemo)(function() {
        return (0,differenceInSeconds/* default */.Z)(new Date((0,timeHelper/* convertTimeToSeconds */.Eg)(lockEndTime)), new Date());
    }, [
        lockEndTime
    ]);
    var passedDuration = (0,react.useMemo)(function() {
        return (0,differenceInSeconds/* default */.Z)(new Date(), new Date((0,timeHelper/* convertTimeToSeconds */.Eg)(lockStartTime)));
    }, [
        lockStartTime
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_AddAmountModal, {
        passedDuration: passedDuration,
        currentLockedAmount: currentLockedAmount,
        remainingDuration: remainingDuration,
        currentBalance: currentBalance,
        stakingToken: stakingToken,
        lockEndTime: lockEndTime,
        stakingTokenBalance: stakingTokenBalance
    }), true, true, "AddAmountModal"), 1), openAddAmountModal = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotEnoughTokensModal/* default */.Z, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref1[0];
    var handleClicked = (0,react.useCallback)(function() {
        return currentBalance.gt(0) ? openAddAmountModal() : onPresentTokenRequired();
    }, [
        currentBalance,
        openAddAmountModal,
        onPresentTokenRequired
    ]);
    return userDataLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: handleClicked,
        width: "100%",
        children: t("Add CAKE")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        height: 48
    });
};
/* harmony default export */ var Buttons_AddCakeButton = (/*#__PURE__*/(0,react.memo)(AddCakeButton));


/***/ }),

/***/ 28353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Buttons_ExtendDurationButton; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/components/Divider/index.tsx
var Divider = __webpack_require__(14275);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/StaticAmount.tsx





var StaticAmount = function(param) {
    var stakingSymbol = param.stakingSymbol, stakingAddress = param.stakingAddress, lockedAmount = param.lockedAmount, usdValueStaked = param.usdValueStaked;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: t("Add CAKE to lock")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                                color: "text",
                                bold: true,
                                fontSize: "16px",
                                value: lockedAmount,
                                decimals: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                                value: usdValueStaked,
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                unit: " USD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingAddress, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingSymbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Common_StaticAmount = (StaticAmount);

// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/LockedModalBody.tsx + 1 modules
var LockedModalBody = __webpack_require__(84548);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/index.tsx + 6 modules
var Overview = __webpack_require__(70271);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Modals/RoiCalculatorModalProvider.tsx
var RoiCalculatorModalProvider = __webpack_require__(37972);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Modals/ExtendDurationModal.tsx













var ExtendDurationModal = function(param) {
    var modalTitle = param.modalTitle, stakingToken = param.stakingToken, onDismiss = param.onDismiss, currentLockedAmount = param.currentLockedAmount, currentDuration = param.currentDuration, lockStartTime = param.lockStartTime;
    var theme = (0,useTheme/* default */.Z)().theme;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(currentLockedAmount);
    var validator = (0,react.useCallback)(function(param) {
        var duration = param.duration;
        var isValidAmount = currentLockedAmount && currentLockedAmount > 0;
        var totalDuration = currentDuration + duration;
        var isValidDuration = duration > 0 && totalDuration > 0 && totalDuration <= pools/* MAX_LOCK_DURATION */.VO;
        return {
            isValidAmount: isValidAmount,
            isValidDuration: isValidDuration,
            isOverMax: totalDuration > pools/* MAX_LOCK_DURATION */.VO
        };
    }, [
        currentLockedAmount,
        currentDuration
    ]);
    var prepConfirmArg = (0,react.useCallback)(function(param) {
        var duration = param.duration;
        return {
            finalDuration: duration,
            finalLockedAmount: 0
        };
    }, []);
    var customOverview = (0,react.useCallback)(function(param) {
        var isValidDuration = param.isValidDuration, duration = param.duration;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview/* default */.Z, {
            lockStartTime: lockStartTime,
            isValidDuration: isValidDuration,
            openCalculator: (noop_default()),
            duration: currentDuration || duration,
            newDuration: currentDuration + duration,
            lockedAmount: currentLockedAmount,
            usdValueStaked: usdValueStaked,
            showLockWarning: !+lockStartTime
        });
    }, [
        lockStartTime,
        currentDuration,
        currentLockedAmount,
        usdValueStaked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModalProvider/* default */.Z, {
        lockedAmount: currentLockedAmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            title: modalTitle || t("Extend Lock"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_StaticAmount, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        lockedAmount: currentLockedAmount,
                        usdValueStaked: usdValueStaked
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedModalBody/* default */.Z, {
                    stakingToken: stakingToken,
                    onDismiss: onDismiss,
                    lockedAmount: new bignumber/* default */.Z(currentLockedAmount),
                    validator: validator,
                    prepConfirmArg: prepConfirmArg,
                    customOverview: customOverview
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_ExtendDurationModal = (ExtendDurationModal);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/ExtendDurationButton.tsx








var ExtendDurationButton = function(_param) {
    var modalTitle = _param.modalTitle, stakingToken = _param.stakingToken, currentLockedAmount = _param.currentLockedAmount, lockEndTime = _param.lockEndTime, lockStartTime = _param.lockStartTime, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "modalTitle",
        "stakingToken",
        "currentLockedAmount",
        "lockEndTime",
        "lockStartTime",
        "children"
    ]);
    var currentDuration = (0,react.useMemo)(function() {
        return Number(lockEndTime) - Number(lockStartTime);
    }, [
        lockEndTime,
        lockStartTime
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_ExtendDurationModal, {
        modalTitle: modalTitle,
        stakingToken: stakingToken,
        lockStartTime: lockStartTime,
        currentLockedAmount: currentLockedAmount,
        currentDuration: currentDuration
    }), true, true, "ExtendDurationModal"), 1), openExtendDurationModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClick: openExtendDurationModal,
        width: "100%"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var Buttons_ExtendDurationButton = (ExtendDurationButton);


/***/ }),

/***/ 39421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_AfterLockedActions; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useMatchBreakpoints.ts + 1 modules
var useMatchBreakpoints = __webpack_require__(70589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/components/Trans.tsx
var Trans = __webpack_require__(96464);
// EXTERNAL MODULE: ./src/utils/cakePool.ts
var cakePool = __webpack_require__(17101);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var constants_pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/ConvertToFlexibleButton.tsx


















var ConvertToFlexibleButton = function(props) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)();
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var handleUnlock = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var callOptions, receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    callOptions = {
                        gasLimit: constants_pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].gasLimit
                    };
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            var methodArgs = [
                                account
                            ];
                            return callWithGasPrice(vaultPoolContract, "unlock", methodArgs, callOptions);
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: receipt.transactionHash,
                            children: t("Your funds have been staked in the pool")
                        }));
                        // @ts-ignore
                        dispatch((0,pools/* fetchCakeVaultUserData */.x$)({
                            account: account
                        }));
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        t,
        toastSuccess,
        account,
        callWithGasPrice,
        dispatch,
        fetchWithCatchTxError,
        vaultPoolContract
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        disabled: pendingTx,
        onClick: function() {
            return handleUnlock();
        }
    }, props), {
        children: pendingTx ? t("Converting...") : t("Convert to Flexible")
    }));
};
/* harmony default export */ var Buttons_ConvertToFlexibleButton = (/*#__PURE__*/(0,react.memo)(ConvertToFlexibleButton));

// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Buttons/ExtendDurationButton.tsx + 2 modules
var ExtendDurationButton = __webpack_require__(28353);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/AfterLockedActions.tsx









var _obj;
var msg = (_obj = {}, (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.None */.PS.None, null), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.Flexible */.PS.Flexible, null), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.Locked */.PS.Locked, null), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "The lock period has ended. Convert to flexible staking or renew your position to start a new lock staking."
})), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "The lock period has ended. To avoid more rewards being burned, convert to flexible staking or renew your position to start a new lock staking."
})), _obj);
var AfterLockedActions = function(param) {
    var currentLockedAmount = param.currentLockedAmount, stakingToken = param.stakingToken, position = param.position, isInline = param.isInline;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var isDesktopView = isInline && isDesktop;
    var Container = isDesktopView ? Flex/* default */.Z : Box/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: "warning",
        mb: "16px",
        action: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            mt: !isDesktopView && "8px",
            ml: "10px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_ConvertToFlexibleButton, {
                    mb: !isDesktopView && "8px",
                    minWidth: isDesktopView && "200px",
                    mr: isDesktopView && "14px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendDurationButton/* default */.Z, {
                    modalTitle: t("Renew"),
                    lockEndTime: "0",
                    lockStartTime: "0",
                    stakingToken: stakingToken,
                    currentLockedAmount: currentLockedAmount,
                    minWidth: "186px",
                    children: t("Renew")
                })
            ]
        }),
        actionInline: isDesktopView,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
            children: msg[position]
        })
    });
};
/* harmony default export */ var Common_AfterLockedActions = (/*#__PURE__*/(0,react.memo)(AfterLockedActions));


/***/ }),

/***/ 24594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_BalanceField; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx + 2 modules
var BalanceInput = __webpack_require__(35680);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(59739);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useUserEnoughCakeValidator.ts




var useUserEnoughCakeValidator = function(cakeAmount, stakingTokenBalance) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var errorMessage = t("Insufficient CAKE balance");
    var userNotEnoughCake = (0,react.useMemo)(function() {
        if (new bignumber/* default */.Z(cakeAmount).gt((0,formatBalance/* getBalanceAmount */.U4)(stakingTokenBalance, 18))) return true;
        return false;
    }, [
        cakeAmount,
        stakingTokenBalance
    ]);
    return {
        userNotEnoughCake: userNotEnoughCake,
        notEnoughErrorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/BalanceField.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-ba0b795d-0"
})(_templateObject());
var BalanceField = function(param) {
    var stakingAddress = param.stakingAddress, stakingSymbol = param.stakingSymbol, stakingDecimals = param.stakingDecimals, lockedAmount = param.lockedAmount, stakingMax = param.stakingMax, setLockedAmount = param.setLockedAmount, usedValueStaked = param.usedValueStaked, stakingTokenBalance = param.stakingTokenBalance;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(0), percent = ref[0], setPercent = ref[1];
    var ref1 = useUserEnoughCakeValidator(lockedAmount, stakingTokenBalance), userNotEnoughCake = ref1.userNotEnoughCake, notEnoughErrorMessage = ref1.notEnoughErrorMessage;
    var handleStakeInputChange = (0,react.useCallback)(function(input) {
        if (input) {
            var convertedInput = new bignumber/* default */.Z(input).multipliedBy(bigNumber/* BIG_TEN.pow */.xp.pow(stakingDecimals));
            var percentage = Math.floor(convertedInput.dividedBy(stakingMax).multipliedBy(100).toNumber());
            setPercent(percentage > 100 ? 100 : percentage);
        } else {
            setPercent(0);
        }
        setLockedAmount(input);
    }, [
        stakingDecimals,
        stakingMax,
        setLockedAmount
    ]);
    var handleChangePercent = (0,react.useCallback)(function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = stakingMax.dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingDecimals, stakingDecimals);
            setLockedAmount(amountToStake);
        } else {
            setLockedAmount("");
        }
        setPercent(sliderPercent);
    }, [
        stakingMax,
        setLockedAmount,
        stakingDecimals
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("CAKE to lock")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        minWidth: "70px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/tokens/".concat(stakingAddress, ".png"),
                                width: 24,
                                height: 24,
                                alt: stakingSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "4px",
                                bold: true,
                                children: stakingSymbol
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                isWarning: userNotEnoughCake,
                value: lockedAmount,
                onUserInput: handleStakeInputChange,
                currencyValue: "~".concat(usedValueStaked || 0, " USD"),
                decimals: stakingDecimals
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "flex-end",
                mt: "4px",
                mb: "12px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "flex-end",
                    flexDirection: "column",
                    children: userNotEnoughCake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "failure",
                        children: notEnoughErrorMessage
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "8px",
                textAlign: "end",
                color: "textSubtle",
                fontSize: "12px",
                mb: "8px",
                children: t("Balance: %balance%", {
                    balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingMax, stakingDecimals)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                min: 0,
                max: 100,
                value: percent,
                onValueChanged: handleChangePercent,
                name: "stake",
                valueLabel: "".concat(percent, "%"),
                step: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                mt: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(25);
                        },
                        children: "25%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(50);
                        },
                        children: "50%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(75);
                        },
                        children: "75%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        scale: "xs",
                        mx: "2px",
                        p: "4px 16px",
                        variant: "tertiary",
                        onClick: function() {
                            return handleChangePercent(100);
                        },
                        children: t("Max")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Common_BalanceField = (/*#__PURE__*/(0,react.memo)(BalanceField));


/***/ }),

/***/ 88028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var hooks_useInterval__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76159);
/* harmony import */ var utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87218);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9070);
/* harmony import */ var date_fns_addSeconds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61973);
/* harmony import */ var date_fns_differenceInSeconds__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11699);
/* harmony import */ var utils_timeHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14011);








var BurningCountDown = function(param) {
    var lockEndTime = param.lockEndTime;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), remainingSeconds = ref[0], setRemainingSeconds = ref[1];
    // 1 week after lockEndTime
    var burnDate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,date_fns_addSeconds__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,utils_timeHelper__WEBPACK_IMPORTED_MODULE_5__/* .convertTimeToSeconds */ .Eg)(lockEndTime), config_constants_pools__WEBPACK_IMPORTED_MODULE_3__/* .UNLOCK_FREE_DURATION */ .by);
    }, [
        lockEndTime
    ]);
    var updateRemainingSeconds = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setRemainingSeconds((0,date_fns_differenceInSeconds__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(burnDate, new Date()));
    }, [
        burnDate
    ]);
    // Update every minute
    (0,hooks_useInterval__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(updateRemainingSeconds, 1000 * 60);
    var ref1 = (0,utils_getTimePeriods__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(remainingSeconds), days = ref1.days, hours = ref1.hours, minutes = ref1.minutes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: "".concat(days, "d: ").concat(hours, "h: ").concat(minutes, "m")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BurningCountDown));


/***/ }),

/***/ 24416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70589);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99150);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var hooks_useVaultApy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41273);
/* harmony import */ var _hooks_useAvgLockDuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65683);





var ConvertToLock = function(param) {
    var stakingToken = param.stakingToken, currentStakedAmount = param.currentStakedAmount, isInline = param.isInline;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var isMobile = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().isMobile;
    var isTableView = isInline && !isMobile;
    var avgLockDurationsInSeconds = (0,_hooks_useAvgLockDuration__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().avgLockDurationsInSeconds;
    var lockedApy = (0,hooks_useVaultApy__WEBPACK_IMPORTED_MODULE_2__/* .useVaultApy */ .o)({
        duration: avgLockDurationsInSeconds
    }).lockedApy;
    return(// <Message
    //   variant="warning"
    //   action={
    //     <Flex mt={!isTableView && '8px'} flexGrow={1} ml={isTableView && '80px'}>
    //       <ExtendButton
    //         modalTitle={t('Convert to Lock')}
    //         lockEndTime="0"
    //         lockStartTime="0"
    //         stakingToken={stakingToken}
    //         currentLockedAmount={currentStakedAmount}
    //       >
    //         {t('Convert to Lock')}
    //       </ExtendButton>
    //     </Flex>
    //   }
    //   actionInline={isTableView}
    // >
    //   <MessageText>
    //     {t('Lock staking users are earning an average of %amount%% APY. More benefits are coming soon.', {
    //       amount: lockedApy ? parseFloat(lockedApy).toFixed(2) : 0,
    //     })}
    //   </MessageText>
    // </Message>
    null);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ConvertToLock));


/***/ }),

/***/ 99413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5324);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20253);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41709);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-right: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DURATIONS = [
    1,
    5,
    10,
    25,
    52
];
var StyledInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9d1f5e01-0"
})(_templateObject());
var LockDurationField = function(param) {
    var duration = param.duration, setDuration = param.setDuration, isOverMax = param.isOverMax;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        mb: "8px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "secondary",
                                bold: true,
                                mr: "2px",
                                textTransform: "uppercase",
                                children: t("Add")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("duration")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        flexWrap: "wrap",
                        children: DURATIONS.map(function(week) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                onClick: function() {
                                    return setDuration((0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_10__/* .weeksToSeconds */ .AS)(week));
                                },
                                mt: "4px",
                                mr: [
                                    "2px",
                                    "2px",
                                    "4px",
                                    "4px"
                                ],
                                scale: "sm",
                                variant: (0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_10__/* .weeksToSeconds */ .AS)(week) === duration ? "subtle" : "tertiary",
                                children: [
                                    week,
                                    "W"
                                ]
                            }, week);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, {
                        value: (0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_10__/* .secondsToWeeks */ .Ot)(duration),
                        autoComplete: "off",
                        pattern: "^[0-9]+$",
                        inputMode: "numeric",
                        onChange: function(e) {
                            var ref;
                            var weeks = lodash_toNumber__WEBPACK_IMPORTED_MODULE_3___default()(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                            // Prevent large number input which cause NaN
                            // Why 530, just want to avoid user get laggy experience
                            // For example, allow user put 444 which they still get warning no more than 52
                            if (e.currentTarget.validity.valid && weeks < 530) {
                                var ref1;
                                setDuration((0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_10__/* .weeksToSeconds */ .AS)(lodash_toNumber__WEBPACK_IMPORTED_MODULE_3___default()(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value)));
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: t("Week")
                    })
                ]
            }),
            isOverMax && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                fontSize: "12px",
                textAlign: "right",
                color: "failure",
                children: t("Total lock duration exceeds 52 weeks")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockDurationField);


/***/ }),

/***/ 5450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97114);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99150);



var LockDurationRow = function(param) {
    var weekDuration = param.weekDuration;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: t("Lock Duration")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: "text",
                bold: true,
                fontSize: "16px",
                children: weekDuration
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockDurationRow);


/***/ }),

/***/ 84548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LockedModalBody; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/index.tsx + 6 modules
var Overview = __webpack_require__(70271);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/LockDurationField.tsx
var LockDurationField = __webpack_require__(99413);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var state_pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/hooks/useLockedPool.tsx


















var ONE_WEEK_DEFAULT = 604800;
function useLockedPool(hookArgs) {
    var lockedAmount = hookArgs.lockedAmount, stakingToken = hookArgs.stakingToken, onDismiss = hookArgs.onDismiss, prepConfirmArg = hookArgs.prepConfirmArg;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)();
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref1 = (0,react.useState)(ONE_WEEK_DEFAULT), duration = ref1[0], setDuration = ref1[1];
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(lockedAmount.toNumber());
    var handleDeposit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(convertedStakeAmount, lockDuration) {
            var callOptions, receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        callOptions = {
                            gasLimit: pools/* vaultPoolConfig */.Y4[types/* VaultKey.CakeVault */.om.CakeVault].gasLimit
                        };
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                // .toString() being called to fix a BigNumber error in prod
                                // as suggested here https://github.com/ChainSafe/web3.js/issues/2077
                                var methodArgs = [
                                    convertedStakeAmount.toString(),
                                    lockDuration
                                ];
                                return callWithGasPrice(vaultPoolContract, "deposit", methodArgs, callOptions);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Staked!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the pool")
                            }));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            // @ts-ignore
                            dispatch((0,state_pools/* fetchCakeVaultUserData */.x$)({
                                account: account
                            }));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(convertedStakeAmount, lockDuration) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetchWithCatchTxError,
        toastSuccess,
        dispatch,
        onDismiss,
        account,
        vaultPoolContract,
        t,
        callWithGasPrice
    ]);
    var handleConfirmClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, _finalLockedAmount, finalLockedAmount, _finalDuration, finalDuration, convertedStakeAmount;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ref = typeof prepConfirmArg === "function" ? prepConfirmArg({
                duration: duration
            }) : {}, _finalLockedAmount = ref.finalLockedAmount, finalLockedAmount = _finalLockedAmount === void 0 ? lockedAmount : _finalLockedAmount, _finalDuration = ref.finalDuration, finalDuration = _finalDuration === void 0 ? duration : _finalDuration;
            convertedStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(finalLockedAmount), stakingToken.decimals);
            handleDeposit(convertedStakeAmount, finalDuration);
            return [
                2
            ];
        });
    }), [
        prepConfirmArg,
        stakingToken,
        handleDeposit,
        duration,
        lockedAmount
    ]);
    return {
        usdValueStaked: usdValueStaked,
        duration: duration,
        setDuration: setDuration,
        pendingTx: pendingTx,
        handleConfirmClick: handleConfirmClick
    };
}

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockedModalBody.tsx










var LockedModalBody = function(param) {
    var stakingToken = param.stakingToken, onDismiss = param.onDismiss, lockedAmount = param.lockedAmount, currentBalance = param.currentBalance, editAmountOnly = param.editAmountOnly, prepConfirmArg = param.prepConfirmArg, validator = param.validator, customOverview = param.customOverview;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = useLockedPool({
        stakingToken: stakingToken,
        onDismiss: onDismiss,
        lockedAmount: lockedAmount,
        prepConfirmArg: prepConfirmArg
    }), usdValueStaked = ref.usdValueStaked, duration = ref.duration, setDuration = ref.setDuration, pendingTx = ref.pendingTx, handleConfirmClick = ref.handleConfirmClick;
    var ref1 = (0,react.useMemo)(function() {
        return typeof validator === "function" ? validator({
            duration: duration
        }) : {
            isValidAmount: (lockedAmount === null || lockedAmount === void 0 ? void 0 : lockedAmount.toNumber()) > 0 && (0,formatBalance/* getBalanceAmount */.U4)(currentBalance).gte(lockedAmount),
            isValidDuration: duration > 0 && duration <= pools/* MAX_LOCK_DURATION */.VO,
            isOverMax: duration > pools/* MAX_LOCK_DURATION */.VO
        };
    }, [
        validator,
        currentBalance,
        lockedAmount,
        duration
    ]), isValidAmount = ref1.isValidAmount, isValidDuration = ref1.isValidDuration, isOverMax = ref1.isOverMax;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: editAmountOnly || /*#__PURE__*/ (0,jsx_runtime.jsx)(LockDurationField/* default */.Z, {
                    isOverMax: isOverMax,
                    setDuration: setDuration,
                    duration: duration
                })
            }),
            customOverview ? customOverview({
                isValidDuration: isValidDuration,
                duration: duration
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview/* default */.Z, {
                isValidDuration: isValidDuration,
                openCalculator: (noop_default()),
                duration: duration,
                lockedAmount: lockedAmount === null || lockedAmount === void 0 ? void 0 : lockedAmount.toNumber(),
                usdValueStaked: usdValueStaked,
                showLockWarning: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    isLoading: pendingTx,
                    endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }) : null,
                    onClick: handleConfirmClick,
                    disabled: !(isValidAmount && isValidDuration),
                    children: pendingTx ? t("Confirming") : t("Confirm")
                })
            })
        ]
    });
};
/* harmony default export */ var Common_LockedModalBody = (LockedModalBody);


/***/ }),

/***/ 70271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_Overview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(41273);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(14841);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./src/utils/timeHelper.ts
var timeHelper = __webpack_require__(14011);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/utils/formatSecondsToWeeks.ts
var formatSecondsToWeeks = __webpack_require__(41709);
// EXTERNAL MODULE: ./src/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(12157);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/CrossText.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: line-through;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CrossText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4b9cfd09-0"
})(_templateObject());
/* harmony default export */ var Overview_CrossText = (CrossText);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/TextRow.tsx




var DiffText = function(param) {
    var value = param.value, newValue = param.newValue;
    if ((0,isUndefinedOrNull/* default */.Z)(newValue) || (0,isUndefinedOrNull/* default */.Z)(value) || value === newValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            bold: true,
            fontSize: "16px",
            children: value || "-"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_CrossText, {
                bold: true,
                fontSize: "16px",
                mr: "4px",
                children: value
            }),
            "->",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                color: "failure",
                ml: "4px",
                fontSize: "16px",
                children: newValue
            })
        ]
    });
};
var TextRow = function(param) {
    var title = param.title, value = param.value, newValue = param.newValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiffText, {
                    value: value,
                    newValue: newValue
                })
            })
        ]
    });
};
/* harmony default export */ var Overview_TextRow = (TextRow);

// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/BalanceRow.tsx







var DiffBalance = function(param) {
    var value = param.value, newValue = param.newValue, decimals = param.decimals, unit = param.unit, prefix = param.prefix;
    if ((0,isUndefinedOrNull/* default */.Z)(newValue) || !value || value === newValue || toNumber_default()(newValue) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
            bold: true,
            fontSize: "16px",
            value: value,
            decimals: decimals,
            unit: unit,
            prefix: prefix
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_CrossText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                    bold: true,
                    fontSize: "16px",
                    mr: "4px",
                    value: value,
                    decimals: decimals,
                    unit: unit,
                    prefix: prefix
                })
            }),
            "->",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                bold: true,
                color: "failure",
                fontSize: "16px",
                ml: "4px",
                value: newValue,
                decimals: decimals,
                unit: unit,
                prefix: prefix
            })
        ]
    });
};
var BalanceRow = function(param) {
    var title = param.title, value = param.value, newValue = param.newValue, unit = param.unit, decimals = param.decimals, prefix = param.prefix, suffix = param.suffix, tooltipContent = param.tooltipContent;
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            tooltipContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: title
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textTransform: "uppercase",
                bold: true,
                fontSize: "12px",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiffBalance, {
                        newValue: newValue,
                        value: value,
                        decimals: decimals,
                        unit: unit,
                        prefix: prefix
                    }),
                    suffix
                ]
            })
        ]
    });
};
/* harmony default export */ var Overview_BalanceRow = (/*#__PURE__*/(0,react.memo)(BalanceRow));

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/DateRow.tsx




var DateRow = function(param) {
    var title = param.title, value = param.value, color = param.color;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var tooltipContent = t("You will be able to withdraw the staked CAKE and profit only when the staking position is unlocked, i.e. when the staking period ends.");
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                bold: true,
                color: color,
                children: value ? (0,format["default"])(value, "MMM do, yyyy HH:mm") : "-"
            })
        ]
    });
};
/* harmony default export */ var Overview_DateRow = (DateRow);

// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/utils/formatRoi.ts

function formatRoi(roiArgs) {
    var lockedApy = roiArgs.lockedApy, usdValueStaked = roiArgs.usdValueStaked, duration = roiArgs.duration;
    var roi = usdValueStaked * (Number(lockedApy) / 100) * (duration / 31449600);
    return (0,formatBalance/* formatNumber */.uf)(roi, roi > 10000 ? 0 : 2, roi > 10000 ? 0 : 2);
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(47509);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Modals/RoiCalculatorModalProvider.tsx
var RoiCalculatorModalProvider = __webpack_require__(37972);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Buttons/CalculatorButton.tsx




var CalculatorButton = function() {
    var setShowRoiCalculator = (0,react.useContext)(RoiCalculatorModalProvider/* RoiCalculatorModalContext */.G);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        variant: "text",
        scale: "sm",
        mr: "-8px",
        onClick: function() {
            return setShowRoiCalculator && setShowRoiCalculator(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
            color: "textSubtle",
            width: "18px"
        })
    });
};
/* harmony default export */ var Buttons_CalculatorButton = (CalculatorButton);

;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/Overview/index.tsx















var Overview = function(param) {
    var usdValueStaked = param.usdValueStaked, lockedAmount = param.lockedAmount, duration = param.duration, isValidDuration = param.isValidDuration, newDuration = param.newDuration, newLockedAmount = param.newLockedAmount, lockStartTime = param.lockStartTime, lockEndTime = param.lockEndTime, showLockWarning = param.showLockWarning;
    var ref = (0,useVaultApy/* useVaultApy */.o)(), getLockedApy = ref.getLockedApy, getBoostFactor = ref.getBoostFactor;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var lockedApy = (0,react.useMemo)(function() {
        return getLockedApy(duration);
    }, [
        getLockedApy,
        duration
    ]);
    var boostFactor = (0,react.useMemo)(function() {
        return getBoostFactor(duration);
    }, [
        getBoostFactor,
        duration
    ]);
    var newLockedApy = (0,react.useMemo)(function() {
        return newDuration && getLockedApy(newDuration) || 0;
    }, [
        getLockedApy,
        newDuration
    ]);
    var newBoost = (0,react.useMemo)(function() {
        return newDuration && getBoostFactor(newDuration) || 0;
    }, [
        getBoostFactor,
        newDuration
    ]);
    var formattedRoi = (0,react.useMemo)(function() {
        return formatRoi({
            usdValueStaked: usdValueStaked,
            lockedApy: lockedApy,
            duration: duration
        });
    }, [
        lockedApy,
        usdValueStaked,
        duration
    ]);
    var newFormattedRoi = (0,react.useMemo)(function() {
        return newLockedApy && formatRoi({
            usdValueStaked: usdValueStaked,
            lockedApy: newLockedApy,
            duration: newDuration
        });
    }, [
        newLockedApy,
        usdValueStaked,
        newDuration
    ]);
    var now = new Date();
    var unlockDate = newDuration ? (0,addSeconds/* default */.Z)(Number(lockStartTime) ? new Date((0,timeHelper/* convertTimeToSeconds */.Eg)(lockStartTime)) : now, newDuration) : Number(lockEndTime) ? new Date((0,timeHelper/* convertTimeToSeconds */.Eg)(lockEndTime)) : (0,addSeconds/* default */.Z)(now, duration);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "secondary",
                                bold: true,
                                mr: "2px",
                                textTransform: "uppercase",
                                children: t("Lock")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Overview")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightGreyCard */.m5, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Cake to be locked"),
                                value: lockedAmount,
                                newValue: newLockedAmount,
                                decimals: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: "apy",
                                unit: "%",
                                value: toNumber_default()(lockedApy),
                                decimals: 2,
                                newValue: toNumber_default()(newLockedApy),
                                tooltipContent: t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_TextRow, {
                                title: t("duration"),
                                value: isValidDuration && (0,formatSecondsToWeeks/* default */.ZP)(duration),
                                newValue: isValidDuration && newDuration && (0,formatSecondsToWeeks/* default */.ZP)(newDuration)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Yield boost"),
                                unit: "x",
                                value: toNumber_default()(boostFactor),
                                decimals: 2,
                                newValue: toNumber_default()(newBoost),
                                tooltipContent: t("Your yield will be boosted based on the total lock duration of your current fixed term staking position.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_DateRow, {
                                color: toNumber_default()(newDuration) ? "failure" : "text",
                                title: t("Unlock on"),
                                value: isValidDuration && unlockDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview_BalanceRow, {
                                title: t("Expected ROI"),
                                value: formattedRoi,
                                newValue: newFormattedRoi,
                                prefix: "$",
                                decimals: 2,
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons_CalculatorButton, {}),
                                tooltipContent: t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.")
                            })
                        ]
                    })
                ]
            }),
            showLockWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: "16px",
                maxWidth: "370px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                    variant: "warning",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                        children: t("You will be able to withdraw the staked CAKE and profit only when the staking position is unlocked")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Common_Overview = (Overview);


/***/ }),

/***/ 96635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17634);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97114);
/* harmony import */ var hooks_useVaultApy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41273);
/* harmony import */ var components_Balance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20922);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99150);





var YieldBoostRow = function(param) {
    var secondDuration = param.secondDuration;
    var boostFactor = (0,hooks_useVaultApy__WEBPACK_IMPORTED_MODULE_1__/* .useVaultApy */ .o)({
        duration: secondDuration
    }).boostFactor;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var tooltipContent = t("Your yield will be boosted based on the total lock duration of your current fixed term staking position.");
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    ref: targetRef,
                    color: "textSubtle",
                    textTransform: "uppercase",
                    bold: true,
                    fontSize: "12px",
                    children: t("Yield boost")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_2__/* .BalanceWithLoading */ .sC, {
                color: "text",
                bold: true,
                fontSize: "16px",
                value: boostFactor ? boostFactor === null || boostFactor === void 0 ? void 0 : boostFactor.toString() : "0",
                decimals: 2,
                unit: "x"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (YieldBoostRow);


/***/ }),

/***/ 24237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44850);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23917);
/* harmony import */ var hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90834);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99150);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70794);
/* harmony import */ var _Common_BalanceField__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24594);
/* harmony import */ var _Common_LockedModalBody__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84548);
/* harmony import */ var _RoiCalculatorModalProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37972);











var LockedStakeModal = function(param) {
    var onDismiss = param.onDismiss, currentBalance = param.currentBalance, stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance;
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().theme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), lockedAmount = ref[0], setLockedAmount = ref[1];
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var usdValueStaked = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_3__/* .useBUSDCakeAmount */ .Tx)(lodash_toNumber__WEBPACK_IMPORTED_MODULE_5___default()(lockedAmount));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RoiCalculatorModalProvider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        lockedAmount: lockedAmount,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            title: t("Lock CAKE"),
            onDismiss: onDismiss,
            headerBackground: theme.colors.gradients.cardHeader,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    mb: "16px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_BalanceField__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        stakingAddress: stakingToken.address,
                        stakingSymbol: stakingToken.symbol,
                        stakingDecimals: stakingToken.decimals,
                        lockedAmount: lockedAmount,
                        usedValueStaked: usdValueStaked,
                        stakingMax: currentBalance,
                        setLockedAmount: setLockedAmount,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_LockedModalBody__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    currentBalance: currentBalance,
                    stakingToken: stakingToken,
                    onDismiss: onDismiss,
                    lockedAmount: new bignumber_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z(lockedAmount)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockedStakeModal);


/***/ }),

/***/ 37972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ RoiCalculatorModalContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23637);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79833);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_toString__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Vault_VaultRoiCalculatorModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58745);






var RoiCalculatorModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var RoiCalculatorModalProvider = function(param) {
    var children = param.children, lockedAmount = param.lockedAmount;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showRoiCalculator = ref1[0], setShowRoiCalculator = ref1[1];
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    // Get Vault pool
    var pool = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePool */ .AI)(0).pool;
    var stakingTokenAddress = (pool === null || pool === void 0 ? void 0 : (ref = pool.stakingToken) === null || ref === void 0 ? void 0 : ref.address) ? pool.stakingToken.address.toLowerCase() : null;
    if (showRoiCalculator) {
        var ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Vault_VaultRoiCalculatorModal__WEBPACK_IMPORTED_MODULE_5__/* .VaultRoiCalculatorModal */ .E, {
            pool: pool,
            linkLabel: t("Get %symbol%", {
                symbol: "CAKE"
            }),
            linkHref: stakingTokenAddress ? "/swap?outputCurrency=".concat(stakingTokenAddress) : "/swap",
            stakingTokenBalance: pool === null || pool === void 0 ? void 0 : (ref2 = pool.userData) === null || ref2 === void 0 ? void 0 : ref2.stakingTokenBalance,
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: lodash_toString__WEBPACK_IMPORTED_MODULE_4___default()(lockedAmount),
            initialView: 1
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RoiCalculatorModalContext.Provider, {
        value: setShowRoiCalculator,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RoiCalculatorModalProvider);


/***/ }),

/***/ 65683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAvgLockDuration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9070);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70794);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14841);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23637);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35128);
/* harmony import */ var _utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41709);







function useAvgLockDuration() {
    var ref = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCakeVault */ .Xo)(), totalLockedAmount = ref.totalLockedAmount, totalShares = ref.totalShares, totalCakeInVault = ref.totalCakeInVault, pricePerFullShare = ref.pricePerFullShare;
    var avgLockDurationsInSeconds = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var flexibleCakeAmount = totalCakeInVault.minus(totalLockedAmount);
        var flexibleCakeShares = flexibleCakeAmount.div(pricePerFullShare).times(utils_bigNumber__WEBPACK_IMPORTED_MODULE_5__/* .BIG_TEN.pow */ .xp.pow(18));
        var lockedCakeBoostedShares = totalShares.minus(flexibleCakeShares);
        var lockedCakeOriginalShares = totalLockedAmount.div(pricePerFullShare).times(utils_bigNumber__WEBPACK_IMPORTED_MODULE_5__/* .BIG_TEN.pow */ .xp.pow(18));
        var avgBoostRatio = lockedCakeBoostedShares.div(lockedCakeOriginalShares);
        return avgBoostRatio.minus(1).times(new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(config_constants_pools__WEBPACK_IMPORTED_MODULE_1__/* .DURATION_FACTOR.toString */ .A0.toString())).div(new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(config_constants_pools__WEBPACK_IMPORTED_MODULE_1__/* .BOOST_WEIGHT.toString */ .xt.toString()).div(utils_bigNumber__WEBPACK_IMPORTED_MODULE_5__/* .BIG_TEN.pow */ .xp.pow(12))).toFixed(0);
    }, [
        totalCakeInVault,
        totalLockedAmount,
        pricePerFullShare,
        totalShares
    ]);
    var avgLockDurationsInWeeks = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(avgLockDurationsInSeconds);
    }, [
        avgLockDurationsInSeconds
    ]);
    return {
        avgLockDurationsInWeeks: avgLockDurationsInWeeks,
        avgLockDurationsInSeconds: lodash_toNumber__WEBPACK_IMPORTED_MODULE_3___default()(avgLockDurationsInSeconds)
    };
}


/***/ }),

/***/ 51553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99150);
/* harmony import */ var utils_timeHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14011);
/* harmony import */ var _utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41709);



var useUserDataInVaultPresenter = function(param) {
    var lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime;
    var ref = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)(), locale = ref.currentLanguage.locale;
    var secondDuration = Number(lockEndTime) - Number(lockStartTime);
    var lockEndTimeSeconds = (0,utils_timeHelper__WEBPACK_IMPORTED_MODULE_1__/* .convertTimeToSeconds */ .Eg)(lockEndTime);
    var lockEndDate = "";
    try {
        lockEndDate = new Date(lockEndTimeSeconds).toLocaleString(locale, {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
    } catch (_) {
    // ignore invalid format
    }
    return {
        weekDuration: (0,_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(secondDuration),
        remainingTime: (0,utils_timeHelper__WEBPACK_IMPORTED_MODULE_1__/* .distanceToNowStrict */ .At)(lockEndTimeSeconds),
        lockEndDate: lockEndDate,
        secondDuration: secondDuration
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUserDataInVaultPresenter);


/***/ }),

/***/ 41709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ weeksToSeconds; },
/* harmony export */   "Ot": function() { return /* binding */ secondsToWeeks; }
/* harmony export */ });
/* harmony import */ var date_fns_formatDuration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(784);
/* harmony import */ var date_fns_differenceInWeeks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55191);
/* harmony import */ var date_fns_addSeconds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61973);



var secondsToWeeks = function(seconds) {
    var now = new Date();
    var addedDate = (0,date_fns_addSeconds__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(now, seconds);
    return (0,date_fns_differenceInWeeks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(addedDate), now, {
        roundingMethod: "round"
    });
};
var weeksToSeconds = function(weeks) {
    return weeks * 7 * 24 * 60 * 60;
};
var formatSecondsToWeeks = function(secondDuration) {
    return (0,date_fns_formatDuration__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        weeks: secondsToWeeks(secondDuration)
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (formatSecondsToWeeks);


/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modals_CollectModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(62276);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./src/views/Swap/components/SattPasswordModal.tsx
var SattPasswordModal = __webpack_require__(95704);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/utils/getGasPrice.ts
var getGasPrice = __webpack_require__(76582);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(33206);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 16 modules
var contractHelpers = __webpack_require__(93146);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useHarvestPool.ts











var options = {
    gasLimit: config/* DEFAULT_GAS_LIMIT */.QL
};
var harvestPool = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(sousChefContract) {
        var gasPrice;
        return (0,tslib_es6.__generator)(this, function(_state) {
            gasPrice = (0,getGasPrice/* default */.Z)();
            return [
                2,
                sousChefContract.deposit("0", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function harvestPool(sousChefContract) {
        return _ref.apply(this, arguments);
    };
}();
var harvestPoolBnb = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(sousChefContract) {
        var gasPrice;
        return (0,tslib_es6.__generator)(this, function(_state) {
            gasPrice = (0,getGasPrice/* default */.Z)();
            return [
                2,
                sousChefContract.deposit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    value: bigNumber/* BIG_ZERO */.HW,
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function harvestPoolBnb(sousChefContract) {
        return _ref.apply(this, arguments);
    };
}();
var useHarvestPool = function(sousId) {
    var isUsingBnb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var ref = (0,hooks/* useSattWallet */.M)(), sattAddress = ref.sattAddress, getSattSigner = ref.getSattSigner;
    var handleHarvest = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(password) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (sattAddress && password) {
                    // eslint-disable-next-line
                    sousChefContract = (0,contractHelpers/* getSouschefContract */.KV)(sousId, getSattSigner(password));
                }
                if (isUsingBnb) {
                    return [
                        2,
                        harvestPoolBnb(sousChefContract)
                    ];
                }
                return [
                    2,
                    harvestPool(sousChefContract)
                ];
            });
        });
        return function(password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isUsingBnb,
        sousChefContract
    ]);
    return {
        onReward: handleHarvest
    };
};
/* harmony default export */ var hooks_useHarvestPool = (useHarvestPool);

// EXTERNAL MODULE: ./src/views/Pools/hooks/useStakePool.ts
var useStakePool = __webpack_require__(2930);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/CollectModal.tsx



















var CollectModal = function(param) {
    var formattedBalance = param.formattedBalance, fullBalance = param.fullBalance, earningToken = param.earningToken, earningsDollarValue = param.earningsDollarValue, sousId = param.sousId, isBnbPool = param.isBnbPool, _isCompoundPool = param.isCompoundPool, isCompoundPool = _isCompoundPool === void 0 ? false : _isCompoundPool, onDismiss = param.onDismiss, setLoading = param.setLoading;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.Z)().theme;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,hooks/* useSattWallet */.M)(), sattAddress = ref.sattAddress, isSattConnected = ref.isSattConnected;
    var address = account || sattAddress || undefined;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, pendingTx = ref1.loading;
    var onReward = hooks_useHarvestPool(sousId, isBnbPool).onReward;
    var onStake = (0,useStakePool/* default */.Z)(sousId, isBnbPool).onStake;
    var ref2 = (0,react.useState)(isCompoundPool), shouldCompound = ref2[0], setShouldCompound = ref2[1];
    var ref3 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "12px",
                children: t("Compound: collect and restake CAKE into pool.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Harvest: collect CAKE and send to wallet")
            })
        ]
    }), {
        placement: "bottom-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref3.targetRef, tooltip = ref3.tooltip, tooltipVisible = ref3.tooltipVisible;
    var onSattHarvest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(password) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                if (shouldCompound) {
                                    return onStake(fullBalance, earningToken.decimals);
                                }
                                return onReward(password);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            if (shouldCompound) {
                                toastSuccess("".concat(t("Compounded"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been re-invested into the pool!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been sent to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            }
                            setLoading(false);
                            // @ts-ignore
                            dispatch((0,pools/* updateUserStakedBalance */.cR)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserPendingReward */.J4)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserBalance */.yi)(sousId, address));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSattHarvest(password) {
            return _ref.apply(this, arguments);
        };
    }();
    // eslint-disable-next-line
    var handleHarvestConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isSattConnected) {
                            return [
                                2,
                                onPresentSattConfirmModal()
                            ];
                        }
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                if (shouldCompound) {
                                    return onStake(fullBalance, earningToken.decimals);
                                }
                                return onReward();
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            if (shouldCompound) {
                                toastSuccess("".concat(t("Compounded"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been re-invested into the pool!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have been sent to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            }
                            // @ts-ignore
                            dispatch((0,pools/* updateUserStakedBalance */.cR)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserPendingReward */.J4)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserBalance */.yi)(sousId, address));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleHarvestConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SattPasswordModal/* default */.Z, {
        confirmSattTransaction: onSattHarvest
    })), 1), onPresentSattConfirmModal = ref4[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: "".concat(earningToken.symbol, " ").concat(isCompoundPool ? t("Collect") : t("Harvest")),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            isCompoundPool && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                        activeIndex: shouldCompound ? 0 : 1,
                        scale: "sm",
                        variant: "subtle",
                        onItemClick: function(index) {
                            return setShouldCompound(!index);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                as: "button",
                                children: t("Compound")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                as: "button",
                                children: t("Harvest")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        ml: "10px",
                        ref: targetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                            color: "textSubtle"
                        })
                    }),
                    tooltipVisible && tooltip
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            shouldCompound ? t("Compounding") : t("Harvesting"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                children: [
                                    formattedBalance,
                                    " ",
                                    earningToken.symbol
                                ]
                            }),
                            earningsDollarValue > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: "~".concat((0,formatBalance/* formatNumber */.uf)(earningsDollarValue), " USD")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mt: "8px",
                onClick: handleHarvestConfirm,
                isLoading: pendingTx,
                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "currentColor"
                }) : null,
                children: pendingTx ? t("Confirming") : t("Confirm")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: onDismiss,
                pb: "0px",
                children: t("Close Window")
            })
        ]
    });
};
/* harmony default export */ var Modals_CollectModal = (CollectModal);


/***/ }),

/***/ 67576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20253);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24788);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d95d08cf-0"
})(_templateObject());
var NotEnoughTokensModal = function(param) {
    var tokenSymbol = param.tokenSymbol, onDismiss = param.onDismiss;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        title: t("%symbol% required", {
            symbol: tokenSymbol
        }),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                color: "failure",
                bold: true,
                children: t("Insufficient %symbol% balance", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                mt: "24px",
                children: t("You’ll need %symbol% to stake in this pool!", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: t("Buy some %symbol%, or make sure your %symbol% isn’t in another pool or LP.", {
                    symbol: tokenSymbol
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                mt: "24px",
                as: "a",
                external: true,
                href: "/swap",
                children: [
                    t("Buy"),
                    " ",
                    tokenSymbol
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
                href: "https://yieldwatch.net",
                external: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    variant: "secondary",
                    mt: "8px",
                    width: "100%",
                    children: [
                        t("Locate Assets"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            color: "primary",
                            ml: "4px"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "text",
                onClick: onDismiss,
                children: t("Close Window")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotEnoughTokensModal);


/***/ }),

/***/ 29458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modals_StakeModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./packages/uikit/src/components/BalanceInput/BalanceInput.tsx + 2 modules
var BalanceInput = __webpack_require__(35680);
// EXTERNAL MODULE: ./packages/uikit/src/components/Slider/Slider.tsx + 1 modules
var Slider = __webpack_require__(59739);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(47509);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/index.tsx + 4 modules
var RoiCalculatorModal = __webpack_require__(97977);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/utils/compoundApyHelpers.ts
var compoundApyHelpers = __webpack_require__(43452);
// EXTERNAL MODULE: ./src/views/Swap/components/SattPasswordModal.tsx
var SattPasswordModal = __webpack_require__(95704);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx + 1 modules
var TransactionConfirmationModal = __webpack_require__(40874);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/PercentageButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-65705e00-0"
})(_templateObject());
var PercentageButton = function(param) {
    var children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        scale: "xs",
        mx: "2px",
        p: "4px 16px",
        variant: "tertiary",
        onClick: onClick,
        children: children
    });
};
/* harmony default export */ var Modals_PercentageButton = (PercentageButton);

// EXTERNAL MODULE: ./src/views/Pools/hooks/useStakePool.ts
var useStakePool = __webpack_require__(2930);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/utils/getGasPrice.ts
var getGasPrice = __webpack_require__(76582);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 16 modules
var contractHelpers = __webpack_require__(93146);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useUnstakePool.ts








var sousUnstake = function(sousChefContract, amount, decimals) {
    var gasPrice = (0,getGasPrice/* default */.Z)();
    var units = (0,lib_esm/* parseUnits */.vz)(amount, decimals);
    return sousChefContract.withdraw(units.toString(), {
        gasPrice: gasPrice
    });
};
var sousEmergencyUnstake = function(sousChefContract) {
    var gasPrice = (0,getGasPrice/* default */.Z)();
    return sousChefContract.emergencyWithdraw({
        gasPrice: gasPrice
    });
};
var useUnstakePool = function(sousId) {
    var enableEmergencyWithdraw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var ref = (0,hooks/* useSattWallet */.M)(), sattAddress = ref.sattAddress, getSattSigner = ref.getSattSigner;
    var handleUnstake = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(amount, decimals, password) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (sattAddress && password) {
                    sousChefContract = (0,contractHelpers/* getSouschefContract */.KV)(sousId, getSattSigner(password));
                }
                if (enableEmergencyWithdraw) {
                    return [
                        2,
                        sousEmergencyUnstake(sousChefContract)
                    ];
                }
                return [
                    2,
                    sousUnstake(sousChefContract, amount, decimals)
                ];
            });
        });
        return function(amount, decimals, password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        enableEmergencyWithdraw,
        sousChefContract
    ]);
    return {
        onUnstake: handleUnstake
    };
};
/* harmony default export */ var hooks_useUnstakePool = (useUnstakePool);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/Modals/StakeModal.tsx



function StakeModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    StakeModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






















var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-11696390-0"
})(StakeModal_templateObject());
var AnnualRoiContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-11696390-1"
})(_templateObject1());
var AnnualRoiDisplay = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-11696390-2"
})(_templateObject2());
var StakeModal = function(param) {
    var isBnbPool = param.isBnbPool, pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, stakingTokenPrice = param.stakingTokenPrice, _isRemovingStake = param.isRemovingStake, isRemovingStake = _isRemovingStake === void 0 ? false : _isRemovingStake, onDismiss = param.onDismiss;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningTokenPrice = pool.earningTokenPrice, apr = pool.apr, userData = pool.userData, stakingLimit = pool.stakingLimit, earningToken = pool.earningToken;
    var ref = (0,core_esm/* useWeb3React */.Ge)(), account = ref.account, chainId = ref.chainId;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.Z)().theme;
    var onStake = (0,useStakePool/* default */.Z)(sousId, isBnbPool).onStake;
    var onUnstake = hooks_useUnstakePool(sousId, pool.enableEmergencyWithdraw).onUnstake;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref1 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, pendingTx = ref1.loading;
    var ref2 = (0,react.useState)(""), stakeAmount = ref2[0], setStakeAmount = ref2[1];
    var ref3 = (0,react.useState)(false), hasReachedStakeLimit = ref3[0], setHasReachedStakedLimit = ref3[1];
    var ref4 = (0,react.useState)(0), percent = ref4[0], setPercent = ref4[1];
    var ref5 = (0,react.useState)(false), showRoiCalculator = ref5[0], setShowRoiCalculator = ref5[1];
    var isSattConnected = (0,hooks/* useSattWallet */.M)().isSattConnected;
    var getCalculatedStakingLimit = function() {
        if (isRemovingStake) {
            return userData.stakedBalance;
        }
        return new bignumber/* default */.Z(stakingLimit).gt(0) && new bignumber/* default */.Z(stakingTokenBalance).gt(stakingLimit) ? stakingLimit : stakingTokenBalance;
    };
    var fullDecimalStakeAmount = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(stakeAmount), stakingToken.decimals);
    var userNotEnoughToken = isRemovingStake ? new bignumber/* default */.Z(userData.stakedBalance).lt(fullDecimalStakeAmount) : new bignumber/* default */.Z(userData.stakingTokenBalance).lt(fullDecimalStakeAmount);
    var usdValueStaked = new bignumber/* default */.Z(stakeAmount).times(stakingTokenPrice);
    var formattedUsdValueStaked = !usdValueStaked.isNaN() && (0,formatBalance/* formatNumber */.uf)(usdValueStaked.toNumber());
    var interestBreakdown = (0,compoundApyHelpers/* getInterestBreakdown */.A1)({
        principalInUSD: !usdValueStaked.isNaN() ? usdValueStaked.toNumber() : 0,
        apr: apr,
        earningTokenPrice: earningTokenPrice
    });
    var annualRoi = interestBreakdown[3] * pool.earningTokenPrice;
    var formattedAnnualRoi = (0,formatBalance/* formatNumber */.uf)(annualRoi, annualRoi > 10000 ? 0 : 2, annualRoi > 10000 ? 0 : 2);
    var getTokenLink = stakingToken.address ? "/swap?outputCurrency=".concat(stakingToken.address) : "/swap";
    (0,react.useEffect)(function() {
        if (new bignumber/* default */.Z(stakingLimit).gt(0) && !isRemovingStake) {
            setHasReachedStakedLimit(fullDecimalStakeAmount.plus(userData.stakedBalance).gt(stakingLimit));
        }
    }, [
        stakeAmount,
        stakingLimit,
        userData,
        stakingToken,
        isRemovingStake,
        setHasReachedStakedLimit,
        fullDecimalStakeAmount, 
    ]);
    var ref6 = (0,react.useState)({
        attemptingTxn: false,
        txHash: undefined,
        ShowSattPasswordModal: false
    }), ref7 = ref6[0], attemptingTxn = ref7.attemptingTxn, txHash = ref7.txHash, ShowSattPasswordModal = ref7.ShowSattPasswordModal, setPoolState = ref6[1];
    var onSattStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(password) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPoolState({
                            attemptingTxn: true,
                            txHash: undefined,
                            ShowSattPasswordModal: false
                        });
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                if (isRemovingStake) {
                                    return onUnstake(stakeAmount, stakingToken.decimals, password);
                                }
                                return onStake(stakeAmount, stakingToken.decimals, password);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            setPoolState({
                                attemptingTxn: false,
                                txHash: receipt.transactionHash,
                                ShowSattPasswordModal: false
                            });
                            if (isRemovingStake) {
                                toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have also been harvested to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% funds have been staked in the pool!", {
                                        symbol: stakingToken.symbol
                                    })
                                }));
                            }
                            // @ts-ignore
                            dispatch((0,pools/* updateUserStakedBalance */.cR)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserPendingReward */.J4)(sousId, address));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserBalance */.yi)(sousId, address));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSattStake(password) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleStakeInputChange = function(input) {
        if (input) {
            var convertedInput = (0,formatBalance/* getDecimalAmount */.Qe)(new bignumber/* default */.Z(input), stakingToken.decimals);
            var percentage = Math.floor(convertedInput.dividedBy(getCalculatedStakingLimit()).multipliedBy(100).toNumber());
            setPercent(Math.min(percentage, 100));
        } else {
            setPercent(0);
        }
        setStakeAmount(input);
    };
    var handleChangePercent = function(sliderPercent) {
        if (sliderPercent > 0) {
            var percentageOfStakingMax = new bignumber/* default */.Z(getCalculatedStakingLimit()).dividedBy(100).multipliedBy(sliderPercent);
            var amountToStake = (0,formatBalance/* getFullDisplayBalance */.NJ)(percentageOfStakingMax, stakingToken.decimals, stakingToken.decimals);
            setStakeAmount(amountToStake);
        } else {
            setStakeAmount("");
        }
        setPercent(sliderPercent);
    };
    // eslint-disable-next-line
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isSattConnected) {
                            return [
                                2,
                                setPoolState({
                                    attemptingTxn: false,
                                    txHash: undefined,
                                    ShowSattPasswordModal: true
                                })
                            ];
                        }
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                if (isRemovingStake) {
                                    return onUnstake(stakeAmount, stakingToken.decimals);
                                }
                                return onStake(stakeAmount, stakingToken.decimals);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            if (isRemovingStake) {
                                toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% earnings have also been harvested to your wallet!", {
                                        symbol: earningToken.symbol
                                    })
                                }));
                            } else {
                                toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                    txHash: receipt.transactionHash,
                                    children: t("Your %symbol% funds have been staked in the pool!", {
                                        symbol: stakingToken.symbol
                                    })
                                }));
                            }
                            // @ts-ignore
                            dispatch((0,pools/* updateUserStakedBalance */.cR)(sousId, account));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserPendingReward */.J4)(sousId, account));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserBalance */.yi)(sousId, account));
                            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal/* default */.Z, {
            earningTokenPrice: earningTokenPrice,
            stakingTokenPrice: stakingTokenPrice.toNumber(),
            apr: apr,
            linkLabel: t("Get %symbol%", {
                symbol: stakingToken.symbol
            }),
            linkHref: getTokenLink,
            stakingTokenBalance: userData.stakedBalance.plus(stakingTokenBalance),
            stakingTokenSymbol: stakingToken.symbol,
            earningTokenSymbol: earningToken.symbol,
            onBack: function() {
                return setShowRoiCalculator(false);
            },
            initialValue: stakeAmount
        });
    }
    var pendingText = t("Diposit %token%", {
        token: "token"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        minWidth: "346px",
        title: isRemovingStake ? t("Unstake") : t("Stake in Pool"),
        onDismiss: onDismiss,
        headerBackground: theme.colors.gradients.cardHeader,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationPendingContent */.PU, {
            pendingText: pendingText
        }) : txHash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionSubmittedContent */.rD, {
            chainId: chainId,
            hash: txHash,
            onDismiss: onDismiss,
            currencyToAdd: stakingToken.address
        }) : ShowSattPasswordModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SattPasswordModal/* default */.Z, {
            confirmSattTransaction: onSattStake,
            ShowSattPasswordModal: ShowSattPasswordModal
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                new bignumber/* default */.Z(stakingLimit).gt(0) && !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "secondary",
                    bold: true,
                    mb: "24px",
                    style: {
                        textAlign: "center"
                    },
                    fontSize: "16px",
                    children: t("Max stake for this pool: %amount% %token%", {
                        amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(stakingLimit, stakingToken.decimals, 0),
                        token: stakingToken.symbol
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            bold: true,
                            children: [
                                isRemovingStake ? t("Unstake") : t("Stake"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            minWidth: "70px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/tokens/".concat(stakingToken.address, ".png"),
                                    width: 24,
                                    height: 24,
                                    alt: stakingToken.symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "4px",
                                    bold: true,
                                    children: stakingToken.symbol
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                    value: stakeAmount,
                    onUserInput: handleStakeInputChange,
                    currencyValue: stakingTokenPrice.toNumber() !== 0 && "~".concat(formattedUsdValueStaked || 0, " USD"),
                    isWarning: hasReachedStakeLimit || userNotEnoughToken,
                    decimals: stakingToken.decimals
                }),
                hasReachedStakeLimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "failure",
                    fontSize: "12px",
                    style: {
                        textAlign: "right"
                    },
                    mt: "4px",
                    children: t("Maximum total stake: %amount% %token%", {
                        amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(new bignumber/* default */.Z(stakingLimit), stakingToken.decimals, 0),
                        token: stakingToken.symbol
                    })
                }),
                userNotEnoughToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "failure",
                    fontSize: "12px",
                    style: {
                        textAlign: "right"
                    },
                    mt: "4px",
                    children: t("Insufficient %symbol% balance", {
                        symbol: stakingToken.symbol
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    ml: "auto",
                    color: "textSubtle",
                    fontSize: "12px",
                    mb: "8px",
                    children: t("Balance: %balance%", {
                        balance: (0,formatBalance/* getFullDisplayBalance */.NJ)(getCalculatedStakingLimit(), stakingToken.decimals)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                    min: 0,
                    max: 100,
                    value: percent,
                    onValueChanged: handleChangePercent,
                    name: "stake",
                    valueLabel: "".concat(percent, "%"),
                    step: 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: "8px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                            onClick: function() {
                                return handleChangePercent(25);
                            },
                            children: "25%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                            onClick: function() {
                                return handleChangePercent(50);
                            },
                            children: "50%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                            onClick: function() {
                                return handleChangePercent(75);
                            },
                            children: "75%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_PercentageButton, {
                            onClick: function() {
                                return handleChangePercent(100);
                            },
                            children: t("Max")
                        })
                    ]
                }),
                !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mt: "24px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            mr: "8px",
                            color: "textSubtle",
                            children: [
                                t("Annual ROI at current rates"),
                                ":"
                            ]
                        }),
                        Number.isFinite(annualRoi) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiContainer, {
                            alignItems: "center",
                            onClick: function() {
                                setShowRoiCalculator(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnnualRoiDisplay, {
                                    children: [
                                        "$",
                                        formattedAnnualRoi
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    variant: "text",
                                    scale: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                                        color: "textSubtle",
                                        width: "18px"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 60
                        })
                    ]
                }),
                isRemovingStake && pool.enableEmergencyWithdraw && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    maxWidth: "346px",
                    mt: "24px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        children: t("This pool was misconfigured. Please unstake your tokens from it, emergencyWithdraw method will be used. Your tokens will be returned to your wallet, however rewards will not be harvested.")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    isLoading: pendingTx,
                    endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "currentColor"
                    }) : null,
                    onClick: handleConfirmClick,
                    disabled: !stakeAmount || parseFloat(stakeAmount) === 0 || hasReachedStakeLimit || userNotEnoughToken,
                    mt: "24px",
                    width: "100%",
                    children: pendingTx ? t("Confirming") : t("Confirm")
                }),
                !isRemovingStake && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                    external: true,
                    href: getTokenLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        mt: "8px",
                        variant: "secondary",
                        children: t("Get %symbol%", {
                            symbol: stakingToken.symbol
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Modals_StakeModal = (StakeModal);


/***/ }),

/***/ 91692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PoolStatsInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text_Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Timer.tsx
var Timer = __webpack_require__(22491);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(65335);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(33206);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var hooks = __webpack_require__(37063);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts + 1 modules
var addressHelpers = __webpack_require__(55878);
// EXTERNAL MODULE: ./src/utils/wallet.ts + 1 modules
var wallet = __webpack_require__(84695);
// EXTERNAL MODULE: ./src/views/Pools/helpers.tsx
var helpers = __webpack_require__(53136);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Pools/components/MaxStakeRow.tsx







var MaxStakeRow = function(param) {
    var _small = param.small, small = _small === void 0 ? false : _small, stakingLimit = param.stakingLimit, currentBlock = param.currentBlock, stakingLimitEndBlock = param.stakingLimitEndBlock, stakingToken = param.stakingToken, hasPoolStarted = param.hasPoolStarted;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: small,
                        children: [
                            t("Max. stake per user"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        small: small,
                        children: "".concat((0,formatBalance/* getFullDisplayBalance */.NJ)(stakingLimit, stakingToken.decimals, 0), " ").concat(stakingToken.symbol)
                    })
                ]
            }),
            hasPoolStarted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: small,
                        children: [
                            t("Max. stake limit ends in"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        external: true,
                        href: (0,utils/* getBscScanLink */.s6)(stakingLimitEndBlock, "countdown"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                small: small,
                                value: Math.max(stakingLimitEndBlock - currentBlock, 0),
                                decimals: 0,
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                small: small,
                                ml: "4px",
                                color: "primary",
                                textTransform: "lowercase",
                                children: t("Blocks")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
                                ml: "4px",
                                color: "primary"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_MaxStakeRow = (MaxStakeRow);

// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip_useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var Text_TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/utils/cakePool.ts
var cakePool = __webpack_require__(17101);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/hooks/useAvgLockDuration.tsx
var hooks_useAvgLockDuration = __webpack_require__(65683);
;// CONCATENATED MODULE: ./src/views/Pools/components/Stat.tsx








var StatWrapper = function(param) {
    var children = param.children, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        mb: "2px",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
            label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: children
            })
        ]
    });
};
var PerformanceFee = function(param) {
    var userData = param.userData, performanceFeeAsDecimal = param.performanceFeeAsDecimal;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useTooltip_useTooltip/* default */.Z)(t("Performance fee only applies to the flexible staking rewards."), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var isLock = (0,cakePool/* isLocked */.p1)(userData);
    var isStake = (0,cakePool/* isStaked */.IM)(userData);
    if (!performanceFeeAsDecimal || isLock) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_TooltipText/* default */.Z, {
            ref: targetRef,
            small: true,
            children: t("Performance Fee")
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                ml: "4px",
                small: true,
                children: isStake ? "".concat(performanceFeeAsDecimal, "%") : "0~".concat(performanceFeeAsDecimal, "%")
            })
        ]
    });
};
var TotalToken = function(param) {
    var total = param.total, token = param.token;
    if (total && new bignumber/* default */.Z(total).gte(0)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
            small: true,
            value: (0,formatBalance/* getBalanceNumber */.mW)(total, token.decimals),
            decimals: 0,
            unit: " ".concat(token.symbol)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: "90px",
        height: "21px"
    });
};
var TotalLocked = function(param) {
    var totalLocked = param.totalLocked, lockedToken = param.lockedToken;
    var t = (0,Localization/* useTranslation */.$G)().t;
    return(// <StatWrapper label={<Text small>{t('Total locked')}:</Text>}>
    //   <TotalToken total={totalLocked} token={lockedToken} />
    // </StatWrapper>
    null);
};
var DurationAvg = function() {
    var t = useTranslation().t;
    var ref = useTooltip(t("The average lock duration of all the locked staking positions of other users"), {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var avgLockDurationsInWeeks = useAvgLockDuration().avgLockDurationsInWeeks;
    return /*#__PURE__*/ _jsxs(StatWrapper, {
        label: /*#__PURE__*/ _jsxs(TooltipText, {
            ref: targetRef,
            small: true,
            children: [
                t("Average lock duration"),
                ":"
            ]
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ _jsx(Text, {
                ml: "4px",
                small: true,
                children: avgLockDurationsInWeeks
            })
        ]
    });
};
var TotalStaked = function(param) {
    var totalStaked = param.totalStaked, stakingToken = param.stakingToken;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useTooltip_useTooltip/* default */.Z)(t("Total amount of %symbol% staked in this pool", {
        symbol: stakingToken.symbol
    }), {
        placement: "bottom"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatWrapper, {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_TooltipText/* default */.Z, {
            ref: targetRef,
            small: true,
            children: [
                t("Total staked"),
                ":"
            ]
        }),
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalToken, {
                total: totalStaked,
                token: stakingToken
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolStatsInfo.tsx















var PoolStatsInfo = function(param) {
    var pool = param.pool, account = param.account, _showTotalStaked = param.showTotalStaked, showTotalStaked = _showTotalStaked === void 0 ? true : _showTotalStaked, _alignLinksToRight = param.alignLinksToRight, alignLinksToRight = _alignLinksToRight === void 0 ? true : _alignLinksToRight;
    var ref;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var currentBlock = (0,hooks/* useCurrentBlock */.je)();
    var stakingToken = pool.stakingToken, earningToken = pool.earningToken, totalStaked = pool.totalStaked, startBlock = pool.startBlock, endBlock = pool.endBlock, stakingLimit = pool.stakingLimit, stakingLimitEndBlock = pool.stakingLimitEndBlock, contractAddress = pool.contractAddress, vaultKey = pool.vaultKey, profileRequirement = pool.profileRequirement, isFinished = pool.isFinished;
    var ref1 = (0,pools_hooks/* useVaultPoolByKey */.eB)(vaultKey), totalCakeInVault = ref1.totalCakeInVault, totalLockedAmount = ref1.totalLockedAmount, performanceFeeAsDecimal = ref1.fees.performanceFeeAsDecimal, userData = ref1.userData;
    var tokenAddress = earningToken.address || "";
    var poolContractAddress = (0,addressHelpers/* getAddress */.Kn)(contractAddress);
    var cakeVaultContractAddress = (0,addressHelpers/* getVaultPoolAddress */.ZX)(vaultKey);
    var isMetaMaskInScope = !!((ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isMetaMask);
    var ref2 = (0,helpers/* getPoolBlockInfo */.zy)(pool, currentBlock), shouldShowBlockCountdown = ref2.shouldShowBlockCountdown, blocksUntilStart = ref2.blocksUntilStart, blocksRemaining = ref2.blocksRemaining, hasPoolStarted = ref2.hasPoolStarted, blocksToDisplay = ref2.blocksToDisplay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            profileRequirement && (profileRequirement.required || new bignumber/* default */.Z(profileRequirement.thresholdPoints).gt(0)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "8px",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: true,
                        children: [
                            t("Requirement"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: true,
                        textAlign: "right",
                        children: [
                            profileRequirement.required && t("Pancake Profile"),
                            " ",
                            new bignumber/* default */.Z(profileRequirement.thresholdPoints).gt(0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                small: true,
                                children: [
                                    new bignumber/* default */.Z(profileRequirement.thresholdPoints).toNumber().toLocaleString(),
                                    " ",
                                    t("Profile Points")
                                ]
                            })
                        ]
                    })
                ]
            }),
            showTotalStaked && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalStaked, {
                totalStaked: vaultKey ? totalCakeInVault : totalStaked,
                stakingToken: stakingToken
            }),
            vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalLocked, {
                totalLocked: totalLockedAmount,
                lockedToken: stakingToken
            }),
            !isFinished && stakingLimit && stakingLimit.gt(0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MaxStakeRow, {
                small: true,
                currentBlock: currentBlock,
                hasPoolStarted: hasPoolStarted,
                stakingLimit: stakingLimit,
                stakingLimitEndBlock: stakingLimitEndBlock,
                stakingToken: stakingToken
            }),
            shouldShowBlockCountdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: true,
                        children: [
                            hasPoolStarted ? t("Ends in") : t("Starts in"),
                            ":"
                        ]
                    }),
                    blocksRemaining || blocksUntilStart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            external: true,
                            href: (0,utils/* getBscScanLink */.s6)(hasPoolStarted ? endBlock : startBlock, "countdown"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                    small: true,
                                    value: blocksToDisplay,
                                    decimals: 0,
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    small: true,
                                    ml: "4px",
                                    color: "primary",
                                    textTransform: "lowercase",
                                    children: t("Blocks")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
                                    ml: "4px",
                                    color: "primary"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "54px",
                        height: "21px"
                    })
                ]
            }),
            vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerformanceFee, {
                userData: userData,
                performanceFeeAsDecimal: performanceFeeAsDecimal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "/info/token/".concat(earningToken.address),
                    bold: false,
                    small: true,
                    children: t("See Token Info")
                })
            }),
            !vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: earningToken.projectLink,
                    bold: false,
                    small: true,
                    children: t("View Project Site")
                })
            }),
            vaultKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.pancakeswap.finance/products/syrup-pool/new-cake-pool",
                    bold: false,
                    small: true,
                    children: t("View Tutorial")
                })
            }),
            poolContractAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mb: "2px",
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "".concat(config/* BASE_BSC_SCAN_URL */.OS, "/address/").concat(vaultKey ? cakeVaultContractAddress : poolContractAddress),
                    bold: false,
                    small: true,
                    children: t("View Contract")
                })
            }),
            account && isMetaMaskInScope && tokenAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: alignLinksToRight ? "flex-end" : "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    variant: "text",
                    p: "0",
                    height: "auto",
                    onClick: function() {
                        return (0,wallet/* registerToken */.$P)(tokenAddress, earningToken.symbol, earningToken.decimals, "https://tokens.pancakeswap.finance/images/".concat(tokenAddress, ".png"));
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            color: "primary",
                            fontSize: "14px",
                            children: t("Add to Metamask")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, {
                            ml: "4px"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_PoolStatsInfo = (/*#__PURE__*/(0,react.memo)(PoolStatsInfo));


/***/ }),

/***/ 95506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ProfileRequirementWarning; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67334);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44850);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53629);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);
/* harmony import */ var _hooks_useProfileRequirement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67532);





function ProfileRequirementWarning(param) {
    var profileRequirement = param.profileRequirement;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_hooks_useProfileRequirement__WEBPACK_IMPORTED_MODULE_3__/* .useProfileRequirement */ .f)(profileRequirement), notMeetRequired = ref.notMeetRequired, notMeetThreshold = ref.notMeetThreshold;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "warning",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* .MessageText */ .Y, {
                    children: [
                        notMeetRequired && notMeetThreshold && t("This pool requires active Pancake Profile and %amount% profile points.", {
                            amount: profileRequirement.thresholdPoints.toNumber().toLocaleString()
                        }),
                        notMeetRequired && !notMeetThreshold && t("This pool requires active Pancake Profile"),
                        !notMeetRequired && notMeetThreshold && t("This pool requires %amount% profile points.", {
                            amount: profileRequirement.thresholdPoints.toNumber().toLocaleString()
                        })
                    ]
                }),
                (notMeetRequired || notMeetThreshold) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* .MessageText */ .Y, {
                    bold: true,
                    children: notMeetRequired ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLinkFromReactRouter */ .a, {
                        style: {
                            textDecoration: "underline"
                        },
                        to: "/create-profile",
                        children: [
                            t("Create Profile"),
                            " \xbb"
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLinkFromReactRouter */ .a, {
                        style: {
                            textDecoration: "underline"
                        },
                        to: "/nft/profile",
                        children: [
                            t("Go to Profile"),
                            " \xbb"
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 76189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ VaultPositionTagWithLabel; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Split.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.333 2.667l1.527 1.526-1.92 1.92.947.947 1.92-1.92 1.526 1.527v-4h-4zm-2.666 0h-4v4L4.193 5.14l3.14 3.133v5.06h1.334V7.727L5.14 4.193l1.527-1.526z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Split = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Lock.tsx





var Lock_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.99996 11.3334C8.73329 11.3334 9.33329 10.7334 9.33329 10.0001C9.33329 9.26675 8.73329 8.66675 7.99996 8.66675C7.26663 8.66675 6.66663 9.26675 6.66663 10.0001C6.66663 10.7334 7.26663 11.3334 7.99996 11.3334ZM12 5.33342H11.3333V4.00008C11.3333 2.16008 9.83996 0.666748 7.99996 0.666748C6.15996 0.666748 4.66663 2.16008 4.66663 4.00008V5.33342H3.99996C3.26663 5.33342 2.66663 5.93341 2.66663 6.66675V13.3334C2.66663 14.0667 3.26663 14.6667 3.99996 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V6.66675C13.3333 5.93341 12.7333 5.33342 12 5.33342ZM5.93329 4.00008C5.93329 2.86008 6.85996 1.93341 7.99996 1.93341C9.13996 1.93341 10.0666 2.86008 10.0666 4.00008V5.33342H5.93329V4.00008ZM12 13.3334H3.99996V6.66675H12V13.3334Z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Lock = (Lock_Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Unlock.tsx





var Unlock_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8 11.333c.733 0 1.333-.6 1.333-1.333S8.733 8.667 8 8.667s-1.333.6-1.333 1.333.6 1.333 1.333 1.333zm4-6h-.667V4a3.335 3.335 0 00-6.666 0h1.266c0-1.14.927-2.067 2.067-2.067 1.14 0 2.067.927 2.067 2.067v1.333H4c-.733 0-1.333.6-1.333 1.334v6.666c0 .734.6 1.334 1.333 1.334h8c.733 0 1.333-.6 1.333-1.334V6.667c0-.734-.6-1.334-1.333-1.334zm0 8H4V6.667h8v6.666z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Unlock = (Unlock_Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Hot.tsx





var Hot_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.3933 3.03997C10.9266 2.35331 10.3933 1.71331 9.79329 1.13997C9.55996 0.913306 9.16663 1.12664 9.23329 1.44664C9.35996 2.07331 9.49329 2.89997 9.49329 3.63997C9.49329 5.01331 8.59329 6.12664 7.21996 6.12664C6.19329 6.12664 5.35329 5.50664 4.98663 4.61997C4.91996 4.48664 4.89329 4.40664 4.85329 4.25997C4.77996 3.97997 4.41329 3.89331 4.25329 4.13997C4.13329 4.31997 4.01996 4.49997 3.91329 4.69331C3.11996 6.05331 2.66663 7.63997 2.66663 9.33331C2.66663 12.28 5.05329 14.6666 7.99996 14.6666C10.9466 14.6666 13.3333 12.28 13.3333 9.33331C13.3333 7.00664 12.6133 4.84664 11.3933 3.03997ZM7.80663 12.6666C6.61996 12.6666 5.65996 11.7333 5.65996 10.5733C5.65996 9.49331 6.35996 8.73331 7.53329 8.49331C8.51329 8.29331 9.51996 7.87331 10.22 7.21331C10.4066 7.03997 10.7133 7.11997 10.7666 7.36664C10.92 8.04664 11 8.75331 11 9.46664C11.0066 11.2333 9.57329 12.6666 7.80663 12.6666Z",
            fill: "currentColor"
        })
    }));
};
/* harmony default export */ var Hot = (Hot_Icon);

// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(24930);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/components/Trans.tsx
var Trans = __webpack_require__(96464);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/cakePool.ts
var cakePool = __webpack_require__(17101);
;// CONCATENATED MODULE: ./src/views/Pools/components/Vault/VaultPositionTag.tsx











var _obj;
var tagConfig = (_obj = {}, (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.None */.PS.None, {}), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.Flexible */.PS.Flexible, {
    variant: "success"
}), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.Locked */.PS.Locked, {
    variant: "secondary"
}), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd, {
    variant: "secondary",
    outline: true
}), (0,_define_property/* default */.Z)(_obj, cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning, {
    variant: "failure",
    outline: true
}), _obj);
var _obj1;
var iconConfig = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, cakePool/* VaultPosition.None */.PS.None, null), (0,_define_property/* default */.Z)(_obj1, cakePool/* VaultPosition.Flexible */.PS.Flexible, Split), (0,_define_property/* default */.Z)(_obj1, cakePool/* VaultPosition.Locked */.PS.Locked, Lock), (0,_define_property/* default */.Z)(_obj1, cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd, Unlock), (0,_define_property/* default */.Z)(_obj1, cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning, Hot), _obj1);
var _obj2;
var positionLabel = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, cakePool/* VaultPosition.None */.PS.None, ""), (0,_define_property/* default */.Z)(_obj2, cakePool/* VaultPosition.Flexible */.PS.Flexible, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Flexible"
})), (0,_define_property/* default */.Z)(_obj2, cakePool/* VaultPosition.Locked */.PS.Locked, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Locked"
})), (0,_define_property/* default */.Z)(_obj2, cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "Locked End"
})), (0,_define_property/* default */.Z)(_obj2, cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning, /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
    children: "After Burning"
})), _obj2);
var VaultPositionTag = function(param) {
    var position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagConfig[position]), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                as: iconConfig[position],
                mr: "4px"
            }),
            positionLabel[position]
        ]
    }));
};
var VaultPositionTagWithLabel = function(_param) {
    var userData = _param.userData, props = (0,_object_without_properties/* default */.Z)(_param, [
        "userData"
    ]);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var position = (0,react.useMemo)(function() {
        return (0,cakePool/* getVaultPosition */.cP)(userData);
    }, [
        userData
    ]);
    if (position) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* FlexGap */.O, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            alignItems: "center",
            justifyContent: "space-between",
            marginX: "8px",
            mb: "8px",
            gap: "12px"
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "12px",
                    color: "secondary",
                    textTransform: "uppercase",
                    bold: true,
                    children: t("My Position")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPositionTag, {
                    position: position
                })
            ]
        }));
    }
    return null;
};


/***/ }),

/***/ 58745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ VaultRoiCalculatorModal; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/index.tsx + 4 modules
var RoiCalculatorModal = __webpack_require__(97977);
// EXTERNAL MODULE: ./src/components/RoiCalculatorModal/useRoiCalculatorReducer.ts
var useRoiCalculatorReducer = __webpack_require__(44307);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(41273);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./src/utils/compoundApyHelpers.ts
var compoundApyHelpers = __webpack_require__(43452);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/LockDurationField.tsx
var LockDurationField = __webpack_require__(99413);
;// CONCATENATED MODULE: ./src/views/Pools/components/utils/formatSecondsToWeeks.ts



var secondsToWeeks = function(seconds) {
    var now = new Date();
    var addedDate = addSeconds(now, seconds);
    return differenceInWeeks(new Date(addedDate), now, {
        roundingMethod: "round"
    });
};
var weeksToSeconds = function(weeks) {
    return weeks * 7 * 24 * 60 * 60;
};
var formatSecondsToWeeks = function(secondDuration) {
    return formatDuration({
        weeks: secondsToWeeks(secondDuration)
    });
};
/* harmony default export */ var utils_formatSecondsToWeeks = ((/* unused pure expression or super */ null && (formatSecondsToWeeks)));

;// CONCATENATED MODULE: ./src/views/Pools/components/Vault/VaultRoiCalculatorModal.tsx














var VaultRoiCalculatorModal = function(_param) {
    var pool = _param.pool, initialView = _param.initialView, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "pool",
        "initialView"
    ]);
    var ref, ref1;
    var ref2 = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey), _userData = ref2.userData, cakeAsBigNumber = _userData.balance.cakeAsBigNumber;
    var ref3 = (0,useVaultApy/* useVaultApy */.o)(), getLockedApy = ref3.getLockedApy, flexibleApy = ref3.flexibleApy;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref4 = (0,react.useState)(initialView || 0), cakeVaultView = ref4[0], setCakeVaultView = ref4[1];
    var ref5 = (0,react.useState)(weeksToSeconds(1)), duration = ref5[0], setDuration = ref5[1];
    var buttonMenuItems = (0,react.useMemo)(function() {
        return [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                children: t("Flexible")
            }, "Flexible"), 
        ];
    }, [
        t
    ]);
    var apy = (0,react.useMemo)(function() {
        return cakeVaultView === 0 ? flexibleApy : getLockedApy(duration);
    }, [
        cakeVaultView,
        getLockedApy,
        flexibleApy,
        duration
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoiCalculatorModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        stakingTokenSymbol: pool.stakingToken.symbol,
        apy: +apy,
        initialState: {
            controls: {
                compounding: false
            }
        },
        linkHref: "/swap",
        linkLabel: t("Get %symbol%", {
            symbol: pool.stakingToken.symbol
        }),
        earningTokenPrice: pool.stakingTokenPrice.toNumber(),
        stakingTokenPrice: pool.stakingTokenPrice.toNumber(),
        stakingTokenBalance: ((ref = pool.userData) === null || ref === void 0 ? void 0 : ref.stakingTokenBalance) ? cakeAsBigNumber.plus((ref1 = pool.userData) === null || ref1 === void 0 ? void 0 : ref1.stakingTokenBalance) : cakeAsBigNumber,
        autoCompoundFrequency: 1,
        strategy: cakeVaultView ? function(state, dispatch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedRoiStrategy, {
                state: state,
                dispatch: dispatch,
                stakingTokenPrice: pool.stakingTokenPrice,
                earningTokenPrice: pool.earningTokenPrice,
                duration: duration
            });
        } : null,
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenu/* default */.Z, {
            mb: "24px",
            fullWidth: true,
            scale: "sm",
            variant: "subtle",
            activeIndex: cakeVaultView,
            onItemClick: setCakeVaultView,
            children: buttonMenuItems
        })
    }, rest), {
        children: cakeVaultView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: "16px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockDurationField/* default */.Z, {
                duration: duration,
                setDuration: setDuration,
                isOverMax: false
            })
        })
    }));
};
function LockedRoiStrategy(param) {
    var state = param.state, dispatch = param.dispatch, earningTokenPrice = param.earningTokenPrice, duration = param.duration, stakingTokenPrice = param.stakingTokenPrice;
    var getLockedApy = (0,useVaultApy/* useVaultApy */.o)().getLockedApy;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, roiUSD = _data.roiUSD;
    var _controls = state.controls, compounding = _controls.compounding, compoundingFrequency = _controls.compoundingFrequency, stakingDuration = _controls.stakingDuration, mode = _controls.mode;
    (0,react.useEffect)(function() {
        if (mode === useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL) {
            var principalInUSDAsNumber = parseFloat(principalAsUSD);
            var interest = principalInUSDAsNumber / earningTokenPrice * (+getLockedApy(duration) / 100) * (duration / 31449600);
            var hasInterest = !Number.isNaN(interest);
            var roiTokens = hasInterest ? interest : 0;
            var roiAsUSD = hasInterest ? roiTokens * earningTokenPrice : 0;
            var roiPercentage = hasInterest ? (0,compoundApyHelpers/* getRoi */.Lu)({
                amountEarned: roiAsUSD,
                amountInvested: principalInUSDAsNumber
            }) : 0;
            dispatch({
                type: "setRoi",
                payload: {
                    roiUSD: roiAsUSD,
                    roiTokens: roiTokens,
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        principalAsUSD,
        stakingDuration,
        earningTokenPrice,
        compounding,
        compoundingFrequency,
        mode,
        duration,
        dispatch,
        getLockedApy, 
    ]);
    (0,react.useEffect)(function() {
        if (mode === useRoiCalculatorReducer/* CalculatorMode.PRINCIPAL_BASED_ON_ROI */.ee.PRINCIPAL_BASED_ON_ROI) {
            var principalUSD = roiUSD / (+getLockedApy(duration) / 100) / (duration / 31449600);
            var roiPercentage = (0,compoundApyHelpers/* getRoi */.Lu)({
                amountEarned: roiUSD,
                amountInvested: principalUSD
            });
            var principalToken = principalUSD / stakingTokenPrice;
            dispatch({
                type: "setPrincipalForTargetRoi",
                payload: {
                    principalAsUSD: principalUSD.toFixed(2),
                    principalAsToken: principalToken.toFixed(10),
                    roiPercentage: roiPercentage
                }
            });
        }
    }, [
        dispatch,
        duration,
        getLockedApy,
        mode,
        roiUSD,
        stakingTokenPrice
    ]);
    return null;
}


/***/ }),

/***/ 58427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ VaultStakeButtonGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20253);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17634);
/* harmony import */ var components_Layout_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40508);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99150);




var VaultStakeButtonGroup = function(param) {
    var onFlexibleClick = param.onFlexibleClick;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: t("Flexible staking offers flexibility for staking/unstaking whenever you want. Locked staking offers higher APY as well as other benefits.")
    }), {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Flex__WEBPACK_IMPORTED_MODULE_1__/* .FlexGap */ .O, {
                gap: "12px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    style: {
                        flex: 1
                    },
                    onClick: onFlexibleClick,
                    children: t("Stake")
                })
            }),
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mt: "16px",
                small: true,
                ref: targetRef,
                children: t("What’s the difference?")
            })
        ]
    });
};


/***/ }),

/***/ 51029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iB": function() { return /* binding */ useApprovePool; },
  "dI": function() { return /* binding */ useCheckVaultApprovalStatus; },
  "Le": function() { return /* binding */ useVaultApprove; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(9640);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var farms = __webpack_require__(36393);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 3 modules
var pools = __webpack_require__(60385);
;// CONCATENATED MODULE: ./src/state/actions.ts



// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 8 modules
var Toast = __webpack_require__(70141);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(38472);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
// EXTERNAL MODULE: ./src/config/abi/erc20.json
var erc20 = __webpack_require__(93324);
;// CONCATENATED MODULE: ./src/views/Pools/hooks/useApprove.tsx


















var useApprovePool = function(lpContract, sousId, earningTokenSymbol) {
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref1 = (0,hooks/* useSattWallet */.M)(), sattAddress = ref1.sattAddress, getSattSigner = ref1.getSattSigner;
    var address = account || sattAddress || undefined;
    var sousChefContract = (0,useContract/* useSousChef */.AP)(sousId);
    var handleApprove = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(password) {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (sattAddress && password) {
                            // eslint-disable-next-line
                            lpContract = (0,utils/* getContract */.uN)(lpContract === null || lpContract === void 0 ? void 0 : lpContract.address, erc20, getSattSigner(password));
                        }
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(lpContract, "approve", [
                                    sousChefContract.address,
                                    bignumbers/* MaxUint256 */.Bz
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("You can now stake in the %symbol% pool!", {
                                    symbol: earningTokenSymbol
                                })
                            }));
                            // @ts-ignore
                            dispatch((0,pools/* updateUserAllowance */.Oy)(sousId, address));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        address,
        dispatch,
        lpContract,
        sousChefContract,
        sousId,
        earningTokenSymbol,
        t,
        toastSuccess,
        callWithGasPrice,
        fetchWithCatchTxError, 
    ]);
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
// Approve CAKE auto pool
var useVaultApprove = function(setLastUpdated) {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)();
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var ref1 = (0,useContract/* useCake */.kL)(), cakeContract = ref1.signer;
    var handleApprove = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var receipt;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return callWithGasPrice(cakeContract, "approve", [
                                    vaultPoolContract.address,
                                    bignumbers/* MaxUint256 */.Bz
                                ]);
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("You can now stake in the %symbol% vault!", {
                                    symbol: "CAKE"
                                })
                            }));
                            setLastUpdated();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleApprove() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        handleApprove: handleApprove,
        pendingTx: pendingTx
    };
};
var useCheckVaultApprovalStatus = function() {
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,useContract/* useCake */.kL)(), cakeContract = ref.reader;
    var vaultPoolContract = (0,useContract/* useVaultPoolContract */.Ak)();
    var key = (0,react.useMemo)(function() {
        return account ? {
            contract: cakeContract,
            methodName: "allowance",
            params: [
                account,
                vaultPoolContract.address
            ]
        } : null;
    }, [
        account,
        cakeContract,
        vaultPoolContract.address
    ]);
    var ref1 = (0,useSWRContract/* useSWRContract */.Av)(key), data = ref1.data, mutate = ref1.mutate;
    return {
        isVaultApproved: data ? data.gt(0) : false,
        setLastUpdated: mutate
    };
};


/***/ }),

/***/ 67532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useProfileRequirement; }
/* harmony export */ });
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var state_profile_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48650);


function useProfileRequirement(profileRequirement) {
    var ref = (0,state_profile_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useProfile */ .Un)(), profile = ref.profile, hasProfile = ref.hasProfile;
    var notMeetRequired = profileRequirement && profileRequirement.required && (!hasProfile || !profile.isActive);
    var ref1;
    var notMeetThreshold = profileRequirement && new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(profileRequirement === null || profileRequirement === void 0 ? void 0 : profileRequirement.thresholdPoints).gt(0) && new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(profileRequirement === null || profileRequirement === void 0 ? void 0 : profileRequirement.thresholdPoints).gt((ref1 = profile === null || profile === void 0 ? void 0 : profile.points) !== null && ref1 !== void 0 ? ref1 : 0);
    return {
        notMeetRequired: notMeetRequired,
        notMeetThreshold: notMeetThreshold
    };
}


/***/ }),

/***/ 2930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43038);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70794);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33206);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35128);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5039);
/* harmony import */ var utils_getGasPrice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76582);
/* harmony import */ var utils_contractHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93146);
/* harmony import */ var state_satt_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12049);












var options = {
    gasLimit: config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_GAS_LIMIT */ .QL
};
var sousStake = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(sousChefContract, amount) {
        var decimals, gasPrice;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            decimals = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 18;
            gasPrice = (0,utils_getGasPrice__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
            return [
                2,
                sousChefContract.deposit(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(amount).times(utils_bigNumber__WEBPACK_IMPORTED_MODULE_3__/* .BIG_TEN.pow */ .xp.pow(decimals)).toString(), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function sousStake(sousChefContract, amount) {
        return _ref.apply(this, arguments);
    };
}();
var sousStakeBnb = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(sousChefContract, amount) {
        var gasPrice;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            gasPrice = (0,utils_getGasPrice__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
            return [
                2,
                sousChefContract.deposit(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(amount).times(config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_TOKEN_DECIMAL */ .o3).toString(), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function sousStakeBnb(sousChefContract, amount) {
        return _ref.apply(this, arguments);
    };
}();
var useStakePool = function(sousId) {
    var isUsingBnb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var sousChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_4__/* .useSousChef */ .AP)(sousId);
    var ref = (0,state_satt_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useSattWallet */ .M)(), sattAddress = ref.sattAddress, getSattSigner = ref.getSattSigner;
    var handleStake = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(amount, decimals, password) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                if (sattAddress && password) {
                    sousChefContract = (0,utils_contractHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getSouschefContract */ .KV)(sousId, getSattSigner(password));
                }
                if (isUsingBnb) {
                    return [
                        2,
                        sousStakeBnb(sousChefContract, amount)
                    ];
                }
                return [
                    2,
                    sousStake(sousChefContract, amount, decimals)
                ];
            });
        });
        return function(amount, decimals, password) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isUsingBnb,
        sousChefContract
    ]);
    return {
        onStake: handleStake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStakePool);


/***/ }),

/***/ 99119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getHasWithdrawFee; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var getHasWithdrawFee = function(lastDepositedTime) {
    var withdrawalFeePeriod = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 259200;
    var feeEndTime = lastDepositedTime + withdrawalFeePeriod;
    var currentSeconds = Math.floor(Date.now() / 1000);
    var secondsRemainingCalc = feeEndTime - currentSeconds;
    return secondsRemainingCalc > 0;
};
var useWithdrawalFeeTimer = function(lastDepositedTime, userShares) {
    var withdrawalFeePeriod = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 259200;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasUnstakingFee = ref1[0], setHasUnstakingFee = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Math.floor(Date.now() / 1000)), currentSeconds = ref2[0], setCurrentSeconds = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var feeEndTime = lastDepositedTime + withdrawalFeePeriod;
        var secondsRemainingCalc = feeEndTime - currentSeconds;
        var doesUnstakingFeeApply = userShares.gt(0) && secondsRemainingCalc > 0;
        var tick = function() {
            setCurrentSeconds(function(prevSeconds) {
                return prevSeconds + 1;
            });
        };
        var timerInterval = setInterval(function() {
            return tick();
        }, 1000);
        if (doesUnstakingFeeApply) {
            setSecondsRemaining(secondsRemainingCalc);
            setHasUnstakingFee(true);
        } else {
            setHasUnstakingFee(false);
            clearInterval(timerInterval);
        }
        return function() {
            return clearInterval(timerInterval);
        };
    }, [
        lastDepositedTime,
        withdrawalFeePeriod,
        setSecondsRemaining,
        currentSeconds,
        userShares
    ]);
    return {
        hasUnstakingFee: hasUnstakingFee,
        secondsRemaining: secondsRemaining
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useWithdrawalFeeTimer);


/***/ })

}]);